<template>
    <div>
        <div class="col-md-12 mb-2">
                <h4 class="title center-title">Registro de información financiera</h4>
        </div>
        <form v-if="!form.er.locked && ($store.state.isCustomer || $store.state.isGuarantor)" @submit.prevent="validateForm('formER')" data-vv-scope="formER">
            <card  id="toERElement" class="form-horizontal">
                <div class="card-header">
                    <h6 class="card-title-orange">Información adicional</h6>
                </div>
                <div class="card-body">
                    <div class="form-group">
                        <label>Endeudamiento *</label>
                        <vue-numeric  :max=999999999999999 tabindex="0" currency="$" autocomplete="off" name="endeudamiento" v-validate="modelValidations.indebtness" :error="getError('endeudamiento')" separator="." class="form-control" v-model="form.indebtness"></vue-numeric>
                    </div>
                    <div class="form-group">
                        <label>Tipo de cartera *</label>
                        <div class="row" style="margin: 0 0 12px;">
                            <p-checkbox v-model="form.debt.cial" :checked="false">CIAL</p-checkbox>
                            <p-checkbox v-model="form.debt.mc" class="ml-2" :checked="false">MC</p-checkbox>
                        </div>
                    </div>
                </div>
                <div class="card-footer">
                    <div class="text-right">
                        <!-- <p-button @click="validateForm('formER')" class="btn btn-warning">Siguiente</p-button> -->
                        <p-button @click="toBusinessReferences()" type="default" class="pull-left mb-3">Atrás</p-button>
                    </div>
                </div>
            </card>
        </form>
        <form v-if="!form.if.locked" @submit.prevent="validateForm('formIF')" data-vv-scope="formIF">
            <card  id="toIFElement" class="form-horizontal">
                <div class="card-header">
                    <h6 class="card-title-orange">Ingresos familiares</h6>
                </div>
                <div class="card-body">
                    <div class="form-group">
                        <label>Ingresos del negocio</label>
                        <vue-numeric  :max=999999999999999 tabindex="13" currency="$" autocomplete="off" name="ingresos" v-validate="modelValidations.sales" data-vv-id = "formIF.ingresos" :error="getError('formIF.ingresos')" separator="." class="form-control" v-model="form.if.incomes.business_income"></vue-numeric>
                    </div>
                    <div class="form-group">
                        <label>Salario/Pensión titular</label>
                        <vue-numeric  :max=999999999999999 tabindex="14" disabled currency="$" autocomplete="off" name="salario" v-validate="modelValidations.sales" data-vv-id = "formIF.salario" :error="getError('formIF.salario')" separator="." class="form-control" v-model="form.if.incomes.titular_salary"></vue-numeric>
                    </div>
                    <div class="form-group">
                        <label>Salario/Pensión cónyuge</label>
                        <vue-numeric  :max=999999999999999 disabled tabindex="15" currency="$" autocomplete="off" name="salario" v-validate="modelValidations.sales" data-vv-id = "formIF.salario" :error="getError('formIF.salario')" separator="." class="form-control" v-model="form.if.incomes.spouse_salary"></vue-numeric>
                    </div>
                    <div class="form-group">
                        <label>Otros ingresos netos</label>
                        <!-- <vue-numeric  :max=999999999999999 v-on:focus="equipmentFocus(1)" tabindex="16" currency="$" autocomplete="off" name="otros" v-validate="modelValidations.sales" data-vv-id = "formIF.otros" :error="getError('formIF.otros')" separator="." class="form-control" v-model="form.if.incomes.others"></vue-numeric> -->
                        <vue-numeric  :max=999999999999999 id="otherIncomes" v-on:focus="otherIncomesFocus()" tabindex="16" currency="$" autocomplete="off" name="otros" v-validate="modelValidations.sales" data-vv-id = "formIF.otros" :error="getError('formIF.otros')" separator="." class="form-control" v-model="incomes_others_computed"></vue-numeric>
                    </div>
                    <el-table v-if="form.if.otherIncomes.length" :data="form.if.otherIncomes"  ref="incomesTable"  highlight-current-row @current-change="handleCurrentIncomesChange">
                        <el-table-column label="Tipo">
                            <template slot-scope="scope">
                                <span >{{ setIncomeType(scope.row.incomeType)}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="Valor">
                            <template slot-scope="scope">
                                <span >{{ setFormat(scope.row.incomeValue)}}</span>
                            </template>
                        </el-table-column>
                    </el-table>
                    <p-button v-if="currentIncomesRow"
                        @click="editIncomesMethod()"
                        type="default" 
                        >
                        <i class="mr-2 fa fa-pencil"></i>Editar
                    </p-button>
                    <br>
                    <p-button v-if="currentIncomesRow"
                        @click="removeIncomesMethod()"
                        type="default" 
                        >
                        <i class="mr-2 fa fa-minus"></i>Quitar
                    </p-button>
                    <div class="alert alert-warning mt-2">
                        <span>Total ingresos: {{setFormat(family_income_computed)}}</span>
                    </div>
                    <div v-show="$store.state.isCustomer || $store.state.isGuarantor">
                        <h6 class="orange">Egresos de la unidad familiar</h6>
                        <div class="form-group">
                            <label>Alquiler</label>
                            <vue-numeric  :max=999999999999999 tabindex="17" currency="$" autocomplete="off" name="alquiler" v-validate="modelValidations.sales" data-vv-id = "formIF.alquiler" :error="getError('formIF.alquiler')" separator="." class="form-control" v-model="form.if.expenses.rental"></vue-numeric>
                        </div>
                        <div class="form-group">
                            <label>Alimentación</label>
                            <vue-numeric  :max=999999999999999 tabindex="18" currency="$" autocomplete="off" name="alimentación" v-validate="modelValidations.sales" data-vv-id = "formIF.alimentación" :error="getError('formIF.alimentación')" separator="." class="form-control" v-model="form.if.expenses.feeding"></vue-numeric>
                        </div>
                        <div class="form-group">
                            <label>Servicios públicos</label>
                            <vue-numeric  :max=999999999999999 tabindex="19" currency="$" autocomplete="off" name="servicios" v-validate="modelValidations.sales" data-vv-id = "formIF.servicios" :error="getError('formIF.servicios')" separator="." class="form-control" v-model="form.if.expenses.public_services"></vue-numeric>
                        </div>
                        <div class="form-group">
                            <label>Educación</label>
                            <vue-numeric  :max=999999999999999 tabindex="20" currency="$" autocomplete="off" name="educación" v-validate="modelValidations.sales" data-vv-id = "formIF.educación" :error="getError('formIF.educación')" separator="." class="form-control" v-model="form.if.expenses.education"></vue-numeric>
                        </div>
                        <div class="form-group">
                            <label>Salud</label>
                            <vue-numeric  :max=999999999999999 tabindex="21" currency="$" autocomplete="off" name="salud" v-validate="modelValidations.sales" data-vv-id = "formIF.salud" :error="getError('formIF.salud')" separator="." class="form-control" v-model="form.if.expenses.health"></vue-numeric>
                        </div>
                        <div class="form-group">
                            <label>Cuotas créditos recibidos por UF</label>
                            <vue-numeric  :max=999999999999999 tabindex="22" currency="$" autocomplete="off" name="cuotas" v-validate="modelValidations.sales" data-vv-id = "formIF.cuotas" :error="getError('formIF.cuotas')" separator="." class="form-control" v-model="form.if.expenses.credits"></vue-numeric>
                        </div>
                        <div class="form-group">
                            <label>Transporte</label>
                            <vue-numeric  :max=999999999999999 tabindex="23" currency="$" autocomplete="off" name="transporte" v-validate="modelValidations.sales" data-vv-id = "formIF.transporte" :error="getError('formIF.transporte')" separator="." class="form-control" v-model="form.if.expenses.transport"></vue-numeric>
                        </div>
                        <div class="form-group">
                            <label>Otros</label>
                            <vue-numeric  :max=999999999999999 tabindex="24" currency="$" autocomplete="off" name="otros" v-validate="modelValidations.sales" data-vv-id = "formIF.otros" :error="getError('formIF.otros')" separator="." class="form-control" v-model="form.if.expenses.others"></vue-numeric>
                        </div>
                        <div class="form-group">
                            <label>Imprevistos * 10%</label>
                            <vue-numeric  :max=999999999999999 disabled tabindex="25" currency="$" autocomplete="off" name="imprevistos" v-validate="modelValidations.sales" data-vv-id = "formIF.imprevistos" :error="getError('formIF.imprevistos')" separator="." class="form-control" v-model="family_expenses_incidentals_computed"></vue-numeric>
                        </div>
                        <div class="alert alert-warning mt-2">
                            <span>TOTAL EGRESOS UF: {{setFormat(family_expenses_computed)}}</span>
                        </div>
                        <div class="alert alert-success mt-2">
                            <span>EXCEDENTE: {{setFormat(family_surplus_computed)}}</span>
                        </div>
                    </div>
                </div>
                <div class="card-footer">
                    <div class="text-right">
                            <p-button @click="validateForm('formIF')" class="btn btn-warning">Siguiente</p-button>
                            <p-button @click="toER()" type="default" class="pull-left mb-3">Atrás</p-button>
                    </div>
                </div>
            </card>
        </form>
        <form v-if="!form.b.locked && ($store.state.isCustomer || $store.state.isGuarantor)" @submit.prevent="validateForm('formB')" data-vv-scope="formB">
            <card  id="toBElement" class="form-horizontal">
                <div class="card-header">
                    <h6 class="card-title-orange">Balance</h6>
                </div>
                <div class="card-body">
                    <h6 class="white">ACTIVO</h6>
                    <div class="form-group">
                        <label>Caja</label>
                        <vue-numeric  :max=999999999999999 tabindex="26" currency="$" autocomplete="off" name="caja" v-validate="modelValidations.sales" :error="getError('formB.caja')" separator="." class="form-control" v-model="form.b.assets.cash"></vue-numeric>
                    </div>
                    <div class="form-group">
                        <label>Bancos</label>
                        <vue-numeric  :max=999999999999999 tabindex="27" currency="$" autocomplete="off" name="bancos" v-validate="modelValidations.sales" :error="getError('formB.bancos')" separator="." class="form-control" v-model="form.b.assets.banks"></vue-numeric>
                    </div>
                    <div class="form-group">
                        <label>Cuentas ahorros/CDTs BMM</label>
                        <vue-numeric  :max=999999999999999 tabindex="28" currency="$" autocomplete="off" name="cuentas" v-validate="modelValidations.sales" :error="getError('formB.cuentas')" separator="." class="form-control" v-model="form.b.assets.saving_accounts"></vue-numeric>
                    </div>
                    <div class="form-group">
                        <label>Cuentas a cobrar a clientes</label>
                        <vue-numeric  :max=999999999999999 disabled tabindex="29" currency="$" autocomplete="off" name="cuentas" v-validate="modelValidations.sales" :error="getError('formB.cuentas')" separator="." class="form-control" v-model="form.b.assets.accounts_receivable"></vue-numeric>
                    </div>
                    <div class="form-group">
                        <label>Inventarios</label>
                        <vue-numeric  :max=999999999999999 tabindex="30" currency="$" autocomplete="off" name="inventarios" v-validate="modelValidations.sales" :error="getError('formB.inventarios')" separator="." class="form-control" v-model="form.b.assets.inventory"></vue-numeric>
                    </div>
                    <div class="form-group">
                        <label>Otras cuentas de ahorro corriente</label>
                        <vue-numeric  :max=999999999999999 tabindex="31" currency="$" autocomplete="off" name="cuentas" v-validate="modelValidations.sales" :error="getError('formB.cuentas')" separator="." class="form-control" v-model="form.b.assets.others_accounts"></vue-numeric>
                    </div>
                    <div class="alert alert-warning mt-2">
                        <span>TOTAL ACTIVO CORRIENTE: {{setFormat(total_current_assets_computed)}}</span>
                    </div>
                    <!-- <div class="text-right">
                        <p-button @click="addEquipmentMethod()" type="info"><i class="mr-2 fa fa-plus"></i>Agregar</p-button>
                        <p-button @click="toI()" link type="default">Ir a inmuebles</p-button>
                    </div> -->
                    <div class="form-group">
                        <label>Inmuebles</label>
                        <vue-numeric  :max=999999999999999 v-on:focus="equipmentFocus(1)"  tabindex="32" currency="$" autocomplete="off" name="inmuebles" v-validate="modelValidations.sales" :error="getError('formB.inmuebles')" separator="." class="form-control" v-model="form_estate_computed"></vue-numeric>
                    </div>
                    <div class="form-group">
                        <label>Muebles, maquinaria y equipo</label>
                        <vue-numeric  :max=999999999999999 v-on:focus="equipmentFocus(2)" tabindex="33" currency="$" autocomplete="off" name="muebles" v-validate="modelValidations.sales" :error="getError('formB.muebles')" separator="." class="form-control" v-model="form_equipment_computed"></vue-numeric>
                    </div>
                    <div class="form-group">
                        <label>Vehículo</label>
                        <vue-numeric  :max=999999999999999 v-on:focus="equipmentFocus(3)" tabindex="34" currency="$" autocomplete="off" name="vehículo" v-validate="modelValidations.sales" :error="getError('formB.vehículo')" separator="." class="form-control" v-model="form_vehicle_computed"></vue-numeric>
                    </div>
                    <div class="alert alert-warning mt-2">
                        <span>TOTAL ACTIVO FIJO: {{setFormat(total_fixed_assets_computed)}}</span>
                    </div>
                    <div class="form-group">
                        <label>Otros activos</label>
                        <vue-numeric  :max=999999999999999 tabindex="35" currency="$" autocomplete="off" name="otros" v-validate="modelValidations.sales" :error="getError('formB.otros')" separator="." class="form-control" v-model="form.b.assets.others_assets"></vue-numeric>
                    </div>
                    <div class="alert alert-success mt-2">
                        <span>TOTAL ACTIVO: {{setFormat(total_assets_computed)}}</span>
                    </div>
                    <h6 class="white">PASIVO</h6>
                    <div class="form-group">
                        <label>Cuentas por pagar a proveedores</label>
                        <vue-numeric  :max=999999999999999 tabindex="36" currency="$" autocomplete="off" name="cuentas" v-validate="modelValidations.sales" :error="getError('formB.cuentas')" separator="." class="form-control" v-model="form.b.passives.accounts_payable_suppliers"></vue-numeric>
                    </div>
                    <div class="form-group">
                        <label>Créditos bancarios/IMF para capital de trabajo</label>
                        <vue-numeric  :max=999999999999999 tabindex="37" currency="$" autocomplete="off" name="créditos" v-validate="modelValidations.sales" :error="getError('formB.créditos')" separator="." class="form-control" v-model="form.b.passives.banks_credits"></vue-numeric>
                    </div>
                    <div class="form-group">
                        <label>Créditos BMM para capital de trabajo</label>
                        <vue-numeric  :max=999999999999999 tabindex="38" currency="$" autocomplete="off" name="créditos_BMM" v-validate="modelValidations.sales" :error="getError('formB.créditos_BMM')" separator="." class="form-control" v-model="form.b.passives.BMM_credits"></vue-numeric>
                    </div>
                    <div class="form-group">
                        <label>Otras obligaciones para capital de trabajo</label>
                        <vue-numeric  :max=999999999999999 tabindex="39" currency="$" autocomplete="off" name="obligaciones" v-validate="modelValidations.sales" :error="getError('formB.obligaciones')" separator="." class="form-control" v-model="form.b.passives.others_obligations"></vue-numeric>
                    </div>
                    <div class="alert alert-warning mt-2">
                        <span>TOTAL PASIVO CORRIENTE: {{setFormat(total_current_passives_computed)}}</span>
                    </div>
                    <div class="form-group">
                        <label>Créditos bancarios para activo fijo</label>
                        <vue-numeric  :max=999999999999999 tabindex="40" currency="$" autocomplete="off" name="créditos" v-validate="modelValidations.sales" :error="getError('formB.créditos')" separator="." class="form-control" v-model="form.b.passives.banks_credits_fixed_assets"></vue-numeric>
                    </div>
                    <div class="form-group">
                        <label>Créditos BMM/IMF para activo fijo</label>
                        <vue-numeric  :max=999999999999999 tabindex="41" currency="$" autocomplete="off" name="créditos" v-validate="modelValidations.sales" :error="getError('formB.créditos')" separator="." class="form-control" v-model="form.b.passives.BMM_credits_fixed_assets"></vue-numeric>
                    </div>
                    <div class="form-group">
                        <label>Otras obligaciones para activo fijo</label>
                        <vue-numeric  :max=999999999999999 tabindex="42" currency="$" autocomplete="off" name="obligaciones" v-validate="modelValidations.sales" :error="getError('formB.obligaciones')" separator="." class="form-control" v-model="form.b.passives.others_fixed_assets"></vue-numeric>
                    </div>
                    <div class="alert alert-warning mt-2">
                        <span>TOTAL PASIVO NO CORRIENTE: {{setFormat(total_not_current_passives_computed)}}</span>
                    </div>
                    <div class="alert alert-warning mt-2">
                        <span>TOTAL PASIVO DEL NEGOCIO: {{setFormat(total_business_passives_computed)}}</span>
                    </div>
                    <div class="form-group">
                        <label>Patrimonio</label>
                        <vue-numeric  :max=999999999999999 disabled tabindex="43" currency="$" autocomplete="off" name="patrimonio" v-validate="modelValidations.sales" :error="getError('formB.patrimonio')" separator="." class="form-control" v-model="patrimony_computed"></vue-numeric>
                    </div>
                    <div class="alert alert-success mt-2">
                        <span>TOTAL PASIVO y PATRIMONIO: {{setFormat(total_passive_patrimony_computed)}}</span>
                    </div>
                </div>
                <div class="card-footer">
                    <div class="text-right">
                        <p-button @click="validateForm('formB')" type="warning">Siguiente</p-button>
                        <p-button v-if="validateStudy()" @click="toIF()" type="default" class="pull-left mb-3">Atrás</p-button>
                        <p-button v-else @click="toER()" type="default" class="pull-left mb-3">Atrás</p-button>
                    </div>
                </div>
            </card>
        </form>
        <!--Financial obligations-->
        <!--add financial obligation -->
        <modal :show.sync="addObligation" headerClasses="justify-content-center">
            <h6 slot="header" class="title title-up">Agregar obligación</h6>
                <div class="form-group">
                    <label>Acreedor *</label>
                    <fg-input   type="text"
                                name="acreedor"
                                placeholder="acreedor"
                                autocomplete="off"
                                v-validate="modelValidations.obligation_name"
                                :error="getError('acreedor')"
                                v-model="obligationCreditor">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Monto de crédito *</label>
                    <vue-numeric  :max=999999999999999 currency="$" autocomplete="off" name="monto" v-validate="modelValidations.obligation_value" :error="getError('monto')" separator="." class="form-control" v-model="obligationAmount"></vue-numeric>
                </div>
                <div class="form-group">
                    <label>Valor de cuota *</label>
                    <vue-numeric  :max=999999999999999 currency="$" autocomplete="off" name="monto" v-validate="modelValidations.obligation_value" :error="getError('monto')" separator="." class="form-control" v-model="obligationPaymentValue"></vue-numeric>
                </div>
                <div class="form-group">
                    <label># cuotas pendientes *</label>
                    <fg-input   type="number"
                                name="cuotas"
                                placeholder="cuotas"
                                autocomplete="off"
                                v-validate="modelValidations.obligation_value"
                                :error="getError('cuotas')"
                                v-model="obligationNumberPayments">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Plazo *</label>
                    <fg-input   type="text"
                                name="plazo"
                                placeholder="plazo"
                                autocomplete="off"
                                v-validate="modelValidations.obligation_value"
                                :error="getError('plazo')"
                                v-model="obligationTerm">
                    </fg-input>
                </div>
            <template slot="footer">
                <div class="left-side">
                <p-button type="default" link @click="cancelAddObligation()">Cancelar</p-button>
                </div>
                <div class="divider"></div>
                <div class="right-side">
                <p-button type="default" link @click="addObligationToList()">Agregar</p-button>
                </div>
            </template>
        </modal>
        <!-- /add financial obligation -->
        <!-- edit financial obligation -->
        <modal :show.sync="editObligation" headerClasses="justify-content-center">
            <h6 slot="header" class="title title-up">Editar obligación</h6>
                <div class="form-group">
                    <label>Acreedor *</label>
                    <fg-input   type="text"
                                name="acreedor"
                                placeholder="acreedor"
                                autocomplete="off"
                                v-validate="modelValidations.obligation_name"
                                :error="getError('acreedor')"
                                v-model="obligationCreditor">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Monto de crédito *</label>
                    <vue-numeric  :max=999999999999999 currency="$" autocomplete="off" name="monto" v-validate="modelValidations.obligation_value" :error="getError('monto')" separator="." class="form-control" v-model="obligationAmount"></vue-numeric>
                </div>
                <div class="form-group">
                    <label>Valor de cuota *</label>
                    <vue-numeric  :max=999999999999999 currency="$" autocomplete="off" name="monto" v-validate="modelValidations.obligation_value" :error="getError('monto')" separator="." class="form-control" v-model="obligationPaymentValue"></vue-numeric>
                </div>
                <div class="form-group">
                    <label># cuotas pendientes *</label>
                    <fg-input   type="number"
                                name="cuotas"
                                placeholder="cuotas"
                                autocomplete="off"
                                v-validate="modelValidations.obligation_value"
                                :error="getError('cuotas')"
                                v-model="obligationNumberPayments">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Plazo *</label>
                    <fg-input   type="text"
                                name="plazo"
                                placeholder="plazo"
                                autocomplete="off"
                                v-validate="modelValidations.obligation_value"
                                :error="getError('plazo')"
                                v-model="obligationTerm">
                    </fg-input>
                </div>
            <template slot="footer">
                <div class="left-side">
                <p-button type="default" link @click="cancelEditObligation()">Cancelar</p-button>
                </div>
                <div class="divider"></div>
                <div class="right-side">
                <p-button type="default" link @click="editObligationToList()">Editar</p-button>
                </div>
            </template>
        </modal>
        <modal :show.sync="editFamiliarObligation" headerClasses="justify-content-center">
            <h6 slot="header" class="title title-up">Editar obligación familiar</h6>
                <div class="form-group">
                    <label>Crédito recibido *</label>
                    <fg-input   disabled
                                type="text"
                                name="acreedor"
                                placeholder="acreedor"
                                autocomplete="off"
                                v-validate="modelValidations.obligation"
                                :error="getError('acreedor')"
                                v-model="familiarObligationCreditor">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Monto de crédito *</label>
                    <vue-numeric  :max=999999999999999 currency="$" autocomplete="off" name="monto" v-validate="modelValidations.obligation" :error="getError('monto')" separator="." class="form-control" v-model="familiarObligationAmount"></vue-numeric>
                </div>
                <div class="form-group">
                    <label>Saldo *</label>
                    <vue-numeric  :max=999999999999999 currency="$" autocomplete="off" name="saldo" v-validate="modelValidations.obligation" :error="getError('saldo')" separator="." class="form-control" v-model="familiarObligationResidue"></vue-numeric>
                </div>
                <div class="form-group">
                    <label>Valor de cuota *</label>
                    <vue-numeric  :max=999999999999999 currency="$" autocomplete="off" name="monto" v-validate="modelValidations.obligation" :error="getError('monto')" separator="." class="form-control" v-model="familiarObligationPaymentValue"></vue-numeric>
                </div>
                <div class="form-group">
                    <label>Plazo *</label>
                    <fg-input   type="text"
                                name="plazo"
                                placeholder="plazo"
                                autocomplete="off"
                                v-validate="modelValidations.obligation"
                                :error="getError('plazo')"
                                v-model="familiarObligationTerm">
                    </fg-input>
                </div>
            <template slot="footer">
                <div class="left-side">
                <p-button type="default" link @click="cancelEditFamiliarObligation()">Cancelar</p-button>
                </div>
                <div class="divider"></div>
                <div class="right-side">
                <p-button type="default" link @click="editFamiliarObligationToList()">Editar</p-button>
                </div>
            </template>
        </modal>
        <!-- /edit financial obligation -->
        <form v-if="!form.of.locked && ($store.state.isCustomer || $store.state.isGuarantor)" @submit.prevent="validateForm('formOF')" data-vv-scope="formOF">
            <card  id="toOFElement" class="form-horizontal">
                <div class="card-header">
                    <h6 class="card-title-orange">Obligaciones financieras del negocio</h6>
                </div>
                <div class="card-body">
                    <el-table v-if="form.of.business.obligations.length" :data="form.of.business.obligations"  ref="obligationsTable"  highlight-current-row @current-change="handleCurrentObligationChange">
                        <el-table-column type="expand">
                            <template slot-scope="props">
                                <p>Acreedor: {{ props.row.obligationCreditor }}</p>
                                <p>Monto: {{ setFormat(props.row.obligationAmount) }}</p>
                                <p>Valor cuota: {{ setFormat(props.row.obligationPaymentValue) }}</p>
                                <p># cuotas pendientes: {{ props.row.obligationNumberPayments }}</p>
                                <p>Plazo: {{ props.row.obligationTerm }}</p>
                            </template>
                        </el-table-column>
                        <el-table-column label="Acreedor" property="obligationCreditor"></el-table-column>
                        <el-table-column label="Monto">
                            <template slot-scope="scope">
                                <span >{{ setFormat(scope.row.obligationAmount)}}</span>
                            </template>
                        </el-table-column>
                        <!-- <el-table-column label="Cuota">
                            <template slot-scope="scope">
                                <span >{{ setFormat(scope.row.obligationPaymentValue)}}</span>
                            </template>
                        </el-table-column> -->
                    </el-table>
                    <div>
                        <p-button 
                            @click="addObligationMethod()"
                            type="default" 
                            >
                            <i class="mr-2 fa fa-plus"></i>Agregar obligación
                        </p-button>
                        <br>
                        <p-button v-if="currentObligationRow"
                            @click="editObligationMethod()"
                            type="default" 
                            >
                            <i class="mr-2 fa fa-pencil"></i>Editar obligación
                        </p-button>
                        <br>
                        <p-button v-if="currentObligationRow"
                            @click="removeObligationMethod()"
                            type="default" 
                            >
                            <i class="mr-2 fa fa-minus"></i>Quitar obligación
                        </p-button>
                    </div>
                </div>
                <div class="card-footer">
                    <div class="text-right">
                            <p-button @click="validateForm('formOF')" class="btn btn-warning">Siguiente</p-button>
                            <p-button @click="toB()" type="default" class="pull-left mb-3">Atrás</p-button>
                    </div>
                </div>
            </card>
        </form>
        <form v-if="!form.of.familiar.locked && ($store.state.isCustomer || $store.state.isGuarantor)" @submit.prevent="validateForm('formOFU')" data-vv-scope="formOFU">
            <card id="toOFUElement" class="form-horizontal">
                <div class="card-header">
                    <h6 class="card-title-orange">Obligaciones financieras de la unidad familiar</h6>
                </div>
                <div class="card-body">
                    <el-table v-if="form.of.familiar.familiarObligations.length" :data="form.of.familiar.familiarObligations"  ref="familiarObligationsTable"  highlight-current-row @current-change="handleCurrentFamiliarObligationChange">
                        <el-table-column type="expand">
                            <template slot-scope="props">
                                <p>Créditos recibidos: {{ props.row.obligationCreditor }}</p>
                                <p>Monto: {{ setFormat(props.row.obligationAmount) }}</p>
                                <p>Saldo: {{ setFormat(props.row.obligationResidue) }}</p>
                                <p>Valor cuota: {{ setFormat(props.row.obligationPaymentValue) }}</p>
                                <p>Plazo: {{ props.row.obligationTerm }}</p>
                            </template>
                        </el-table-column>
                        <el-table-column label="Crédito" property="obligationCreditor"></el-table-column>
                        <!-- <el-table-column label="Monto">
                            <template slot-scope="scope">
                                <span >{{ setFormat(scope.row.obligationAmount)}}</span>
                            </template>
                        </el-table-column> -->
                        <el-table-column label="Saldo">
                            <template slot-scope="scope">
                                <span >{{ setFormat(scope.row.obligationResidue)}}</span>
                            </template>
                        </el-table-column>
                    </el-table>
                    <div>
                        <p-button v-if="currentFamiliarObligationRow"
                            @click="editFamiliarObligationMethod()"
                            type="default" 
                            >
                            <i class="mr-2 fa fa-pencil"></i>Editar obligación
                        </p-button>
                    </div>
                    <br>
                    <h6 class="orange">Patrimonio U.F.</h6>
                    <div class="form-group">
                        <label>Valor estimado Casa/Finca</label>
                        <vue-numeric  :max=999999999999999 tabindex="44" currency="$" autocomplete="off" name="patrimonio" v-validate="modelValidations.indebtness" :error="getError('patrimonio')" separator="." class="form-control" v-model="form.of.familiar.patrimonyHouse"></vue-numeric>
                    </div>
                    <div class="form-group">
                        <label>Valor estimado Vehículo</label>
                        <vue-numeric  :max=999999999999999 tabindex="45" currency="$" autocomplete="off" name="patrimonio" v-validate="modelValidations.indebtness" :error="getError('patrimonio')" separator="." class="form-control" v-model="form.of.familiar.patrimonyVehicle"></vue-numeric>
                    </div>
                </div>
                <div class="card-footer">
                    <div class="text-right">
                            <p-button @click="validateForm('formOFU')" class="btn btn-warning">Siguiente</p-button>
                            <p-button @click="toOF()" type="default" class="pull-left mb-3">Atrás</p-button>
                    </div>
                </div>
            </card>
        </form>
        <!-- /Financial obligations-->
        <!-- Equipment  -->
        <!--add Equipment-->
        <modal :show.sync="addEquipment" headerClasses="justify-content-center">
            <h6 slot="header" class="title title-up">Agregar</h6>
                <div class="form-group">
                    <label>Descripción *</label>
                    <fg-input   ref="refEquipment"
                                type="text"
                                name="descripción"
                                placeholder="descripción"
                                autocomplete="off"
                                v-validate="modelValidations.equipment_name"
                                :error="getError('descripción')"
                                v-model="equipmentDescription">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Tipo *</label>
                    <fg-input   name="tipo"
                                v-validate="modelValidations.periodicity"
                                :error="getError('tipo')"
                                v-model="equipmentType">
                            <el-select 
                                    class="select-warning"
                                    size="large"
                                    placeholder="Seleccione..."
                                    v-model="equipmentType">
                            <el-option 
                                    class="select-warning"
                                    value="1"
                                    label="Inmueble">
                            </el-option>
                            <el-option 
                                    class="select-warning"
                                    value="2"
                                    label="Maquinaria/Equipo">
                            </el-option>
                            <el-option 
                                    class="select-warning"
                                    value="3"
                                    label="Vehículo">
                            </el-option>
                        </el-select>
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Valor *</label>
                    <vue-numeric  :max=999999999999999 currency="$" autocomplete="off" name="valor" v-validate="modelValidations.equipment_value" :error="getError('valor')" separator="." class="form-control" v-model="equipmentValue"></vue-numeric>
                </div>
            <template slot="footer">
                <div class="left-side">
                <p-button type="default" link @click="cancelAddEquipment()">Cancelar</p-button>
                </div>
                <div class="divider"></div>
                <div class="right-side">
                <p-button type="default" link @click="addEquipmentToList()">Agregar</p-button>
                </div>
            </template>
        </modal>
        <!--./ add Equipment-->
        <!--add Equipment-->
        <modal :show.sync="editEquipment" headerClasses="justify-content-center">
            <h6 slot="header" class="title title-up">Editar</h6>
                <div class="form-group">
                    <label>Descripción *</label>
                    <fg-input   type="text"
                                name="descipción"
                                placeholder="descipción"
                                autocomplete="off"
                                v-validate="modelValidations.equipment_name"
                                :error="getError('descipción')"
                                v-model="equipmentDescription">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Tipo *</label>
                    <fg-input   name="tipo"
                                v-validate="modelValidations.periodicity"
                                :error="getError('tipo')"
                                v-model="equipmentType">
                            <el-select 
                                    class="select-warning"
                                    size="large"
                                    placeholder="Seleccione..."
                                    v-model="equipmentType">
                            <el-option 
                                    class="select-warning"
                                    value="1"
                                    label="Inmueble">
                            </el-option>
                            <el-option 
                                    class="select-warning"
                                    value="2"
                                    label="Maquinaria/Equipo">
                            </el-option>
                            <el-option 
                                    class="select-warning"
                                    value="3"
                                    label="Vehículo">
                            </el-option>
                        </el-select>
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Valor *</label>
                    <vue-numeric  :max=999999999999999 currency="$" autocomplete="off" name="valor" v-validate="modelValidations.obligation" :error="getError('valor')" separator="." class="form-control" v-model="equipmentValue"></vue-numeric>
                </div>
            <template slot="footer">
                <div class="left-side">
                <p-button type="default" link @click="cancelEditEquipment()">Cancelar</p-button>
                </div>
                <div class="divider"></div>
                <div class="right-side">
                <p-button type="default" link @click="editEquipmentToList()">Editar</p-button>
                </div>
            </template>
        </modal>
        <!--./ add Equipment-->
        <!-- Incomes  -->
        <!--add Incomes-->
        <modal :show.sync="addIncomes" headerClasses="justify-content-center">
            <h6 slot="header" class="title title-up">Agregar</h6>
                <div class="form-group">
                    <label>Tipo *</label>
                    <fg-input   name="tipo"
                                v-validate="modelValidations.periodicity"
                                :error="getError('tipo')"
                                v-model="incomeType">
                            <el-select 
                                    class="select-warning"
                                    size="large"
                                    placeholder="Seleccione..."
                                    v-model="incomeType">
                            <el-option 
                                    class="select-warning"
                                    value="1"
                                    label="Bonificaciones y comisiones">
                            </el-option>
                            <!-- <el-option 
                                    class="select-warning"
                                    value="2"
                                    label="Microempresariales">
                            </el-option> -->
                            <el-option 
                                    class="select-warning"
                                    value="3"
                                    label="Otros">
                            </el-option>
                        </el-select>
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Valor *</label>
                    <vue-numeric  :max=999999999999999 ref="refIncomes" currency="$" autocomplete="off" name="valor" v-validate="modelValidations.equipment_value" :error="getError('valor')" separator="." class="form-control" v-model="incomeValue"></vue-numeric>
                </div>
            <template slot="footer">
                <div class="left-side">
                <p-button type="default" link @click="cancelAddIncomes()">Cancelar</p-button>
                </div>
                <div class="divider"></div>
                <div class="right-side">
                <p-button type="default" link @click="addIncomesToList()">Agregar</p-button>
                </div>
            </template>
        </modal>
        <!--./ add Incomes-->
        <!--add Equipment-->
        <modal :show.sync="editIncomes" headerClasses="justify-content-center">
            <h6 slot="header" class="title title-up">Editar</h6>
                <div class="form-group">
                    <label>Tipo *</label>
                    <fg-input   name="tipo"
                                v-validate="modelValidations.periodicity"
                                :error="getError('tipo')"
                                v-model="incomeType">
                            <el-select 
                                    class="select-warning"
                                    size="large"
                                    placeholder="Seleccione..."
                                    v-model="incomeType">
                            <el-option 
                                    class="select-warning"
                                    value="1"
                                    label="Bonificaciones y comisiones">
                            </el-option>
                            <!-- <el-option 
                                    class="select-warning"
                                    value="2"
                                    label="Microempresariales">
                            </el-option> -->
                            <el-option 
                                    class="select-warning"
                                    value="3"
                                    label="Otros">
                            </el-option>
                        </el-select>
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Valor *</label>
                    <vue-numeric  :max=999999999999999 currency="$" autocomplete="off" name="valor" v-validate="modelValidations.obligation" :error="getError('valor')" separator="." class="form-control" v-model="incomeValue"></vue-numeric>
                </div>
            <template slot="footer">
                <div class="left-side">
                <p-button type="default" link @click="cancelEditIncomes()">Cancelar</p-button>
                </div>
                <div class="divider"></div>
                <div class="right-side">
                <p-button type="default" link @click="editIncomesToList()">Editar</p-button>
                </div>
            </template>
        </modal>
        <!--./ add Incomes-->
        <form v-if="!form.i.equipment.locked && ($store.state.isCustomer || $store.state.isGuarantor)" @submit.prevent="validateForm('formIF')" data-vv-scope="formIF">
            <card  id="toIElement" class="form-horizontal">
                <div class="card-header">
                    <h6 class="card-title-orange">Inmuebles/Muebles, maquinarias, equipos y vehículos del negocio</h6>
                </div>
                <div class="card-body">
                    <el-table v-if="form.i.equipment.equipment.length" :data="form.i.equipment.equipment"  ref="equipmentsTable"  highlight-current-row @current-change="handleCurrentEquipmentChange">
                        <el-table-column label="Descripción" property="equipmentDescription"></el-table-column>
                        <el-table-column label="Valor">
                            <template slot-scope="scope">
                                <span >{{ setFormat(scope.row.equipmentValue)}}</span>
                            </template>
                        </el-table-column>
                    </el-table>
                    <div>
                        <p-button 
                            @click="addEquipmentMethod()"
                            type="default" 
                            >
                            <i class="mr-2 fa fa-plus"></i>Agregar
                        </p-button>
                        <br>
                        <p-button v-if="currentEquipmentRow"
                            @click="editEquipmentMethod()"
                            type="default" 
                            >
                            <i class="mr-2 fa fa-pencil"></i>Editar
                        </p-button>
                        <br>
                        <p-button v-if="currentEquipmentRow"
                            @click="removeEquipmentMethod()"
                            type="default" 
                            >
                            <i class="mr-2 fa fa-minus"></i>Quitar
                        </p-button>
                    </div>
                    <!-- <p-button @click="toB()" link type="default">Ir a balance</p-button> -->
                </div>
                <div class="card-footer">
                    <div v-if="total_equipment_computed != 0" class="alert alert-warning mt-2">
                        <span>TOTAL: {{setFormat(total_equipment_computed)}}</span>
                    </div>
                    <div class="text-right">
                            <p-button @click="validateForm('formI')" class="btn btn-warning">Siguiente</p-button>
                            <p-button v-if="validateStudy()" @click="toOFU()" type="default" class="pull-left mb-3">Atrás</p-button>
                            <p-button v-else @click="toOF()" type="default" class="pull-left mb-3">Atrás</p-button>
                    </div>
                </div>
            </card>
        </form>
        <!--./ Equipment-->
        <!-- Payment capacity-->
        <!--help-->
        <modal :show.sync="showHelp" headerClasses="justify-content-center">
            <h6 slot="header" class="title title-up">Información</h6>
            <div class="alert alert-warning mt-2">
                <span>Información de ayuda: {{helpText}}</span>
            </div>
            <template slot="footer">
                <p-button type="default" link @click="cancelHelp()">Cancelar</p-button>
            </template>
        </modal>
        <!--./ help-->
        <form v-if="!form.cp.locked && ($store.state.isCustomer || $store.state.isGuarantor)" @submit.prevent="validateForm('formCP')" data-vv-scope="formCP">
            <card-orange  id="toCPElement" class="form-horizontal">
                <div class="card-header">
                    <h6 class="card-title-orange">Análisis de la capacidad de pago</h6>
                </div>
                <div class="card-body">
                    <el-table v-if="payment_capacity_computed.length" :data="payment_capacity_computed" @row-dblclick="showHelpMethod" ref="paymentCapacityTable" :row-class-name="tableRowClassName2">
                        <el-table-column label="Variable" property="name"></el-table-column>
                        <el-table-column label="Valor">
                            <template slot-scope="scope">
                                <span >{{ setFormat(scope.row.value)}}</span>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <div class="card-footer">
                    <div class="text-right">
                            <p-button @click="validateForm('formCP')" class="btn btn-warning">Siguiente</p-button>
                            <p-button @click="toI()" type="default" class="pull-left mb-3">Atrás</p-button>
                    </div>
                </div>
            </card-orange>
        </form>
        <!--./ Payment capacity-->
        <!--Financial indicators-->
        <form v-if="!form.i.locked && ($store.state.isCustomer || $store.state.isGuarantor)" @submit.prevent="validateForm('formIFI')" data-vv-scope="formIFI">
            <card  id="toIFIElement" class="form-horizontal">
                <div class="card-header">
                    <h6 class="card-title-orange">Indicadores financieros</h6>
                </div>
                <div class="card-body">
                    <el-table v-if="form.i.financialIndicators.length" :data="form.i.financialIndicators"  @row-dblclick="showHelpMethod" ref="financialIndicatorsTable" :row-class-name="tableRowClassName">
                        <el-table-column label="Indicador" property="name"></el-table-column>
                        <el-table-column label="Valor">
                            <template slot-scope="scope">
                                <span >{{ setSuffix(scope.row)}}</span>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <div class="card-footer">
                    <div class="text-right">
                            <p-button @click="validateForm('formIFI')" class="btn btn-warning">Finalizar</p-button>
                            <p-button @click="toCP()" type="default" class="pull-left mb-3">Atrás</p-button>
                    </div>
                </div>
            </card>
        </form>
        <!--./Financial indicators-->
        <fab
        :position="position"
        :bg-color="bgColor"
        :actions="fabActions"
        main-icon='search'
        icon-size="small"
        @toER="toER"
        @toIF="toIF"
        @toB="toB"
        @toOF="toOF"
        @toOFU="toOFU"
        @toI="toI"
        @toCP="toCP"
        @toIFI="toIFI"
        ></fab>
    </div>
</template>
<script>
import Vue from 'vue'
import swal from 'sweetalert2'
import fab from 'vue-fab'
import VueScrollTo from 'vue-scrollto'
import VueNumeric from 'vue-numeric'
import formatMoney from 'accounting-js/lib/formatMoney.js'
import { Modal } from 'src/components/UIComponents'
import {Select, Option, Table, TableColumn} from 'element-ui'
import FinancialIndicators from 'src/util/FinancialIndicators/FinancialIndicatorsConsumer'
import PaymentCapacity from 'src/util/PaymentCapacity/PaymentCapacityConsumer'
import expr from 'expression-eval'
import moment from 'moment'
import { isEmpty } from 'lodash';
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Select)
Vue.use(Option)
// You can also pass in the default options
Vue.use(VueScrollTo, {
        container: "body",
        duration: 500,
        easing: "ease",
        offset: 0,
        force: true,
        cancelable: true,
        onStart: false,
        onDone: false,
        onCancel: false,
        x: false,
        y: true
})
export default {
    components: {
        fab,
        VueNumeric,
        Modal
    },
    data(){
        return {
            consumer: false,
            microcredit: false,
            modifiedFinancialIndicators: true,
            showHelp: false,
            helpText: null,
            financialIndicators: [],
            currentObligationRow: null,
            currentEquipmentRow: null,
            currentIncomesRow: null,
            currentFamiliarObligationRow: null,
            obligations: [],
            familiarObligations: [{
                obligationCreditor: 'T. de crédito',
                obligationAmount: '',
                obligationResidue: '',
                obligationPaymentValue: '',
                obligationTerm: 0,
            },
            {
                obligationCreditor: 'Cred. consumo',
                obligationAmount: '',
                obligationResidue: '',
                obligationPaymentValue: '',
                obligationTerm: 0,
            },
            {
                obligationCreditor: 'Cred. vivienda',
                obligationAmount: '',
                obligationResidue: '',
                obligationPaymentValue: '',
                obligationTerm: 0,
            }],
            addFamiliarObligation: false,
            editFamiliarObligation: false,
            addObligation: false,
            editObligation: false,
            addEquipment: false,
            editEquipment: false,
            equipmentDescription: '',
            equipmentType: '1',
            equipmentValue: '',
            addIncomes: false,
            editIncomes: false,
            incomeType: '1',
            incomeValue: '',
            familiarObligationCreditor: '',
            familiarObligationAmount: '',
            familiarObligationPaymentValue: '',
            familiarObligationResidue: '',
            familiarObligationTerm: '',
            obligationCreditor: '',
            obligationAmount: '',
            obligationPaymentValue: '',
            obligationNumberPayments: '',
            obligationTerm: '',
            bgColor: '#F09500',
            position: 'bottom-right',
            position2: 'top-right',
            fabActions: [
                {
                    name: 'toER',
                    icon: 'ER'
                },
            ],
            fabActions2: [
                {
                    name: 'toER',
                    icon: 'ER'
                },
                {
                    name: 'toIF',
                    icon: 'IF'
                },
                {
                    name: 'toB',
                    icon: 'B'
                },
                {
                    name: 'toOF',
                    icon: 'OF'
                },
                {
                    name: 'toOFU',
                    icon: 'OFU'
                },
                {
                    name: 'toI',
                    icon: 'I'
                },
                {
                    name: 'toCP',
                    icon: 'CP'
                },
                {
                    name: 'toIFI',
                    icon: 'IFI'
                },
                
            ],
            form: {
                indebtness: '', //Endeudamiento
                debt: { //Tipo de cartera
                    cial: false,
                    mc: false
                },
                er: { //er: estado de resultados
                    locked: false, 
                    employees: 0, //número de empleados
                    account_sales: '', //ventas al contado
                    credit_sales: '', //recuperación de ventas a crédito
                    sales_costs: '', //costo de ventas
                    gross_profit: '', // utilidad bruta
                    net_profit: '', //utilidad neta
                    operative_expenses: { //gastos operativos
                        salaries: {
                            value: '',
                            locked: false
                        }, //salarios
                        rental: {
                            value: '',
                            locked: false
                        },  //alquiler
                        public_services: {
                            value: '',
                            locked: false
                        },  //servicios públicos
                        taxes: {
                            value: '',
                            locked: false
                        },  //impuestos
                        transport: {
                            value: '',
                            locked: false
                        },  //transporte
                        financial_expenses: {
                            value: '',
                            locked: false
                        },  //gastos financieros
                        others: {
                            value: '',
                            locked: false
                        },  //otros
                        incidentals: {
                            value: '',
                            locked: false
                        },  //imprevistos
                        total: '' //total
                    }
                },
                if: { //ingresos familiares
                    locked: false,
                    surplus: '', //excedente
                    incomes: { //ingresos
                        business_income: '', //ingresos del negocio
                        titular_salary: '', //salario del titular
                        spouse_salary: '', //salario conyuge
                        others: '', // otros ingresos netos
                        total: '' //total
                    },
                    otherIncomes: [],
                    expenses: { //egresos
                        rental: '', //alquiler
                        feeding: '', //alimentación
                        public_services: '', //servicios públicos
                        education: '', //educación
                        health: '', //salud
                        credits: '', //cuotas créditos
                        transport: '', //transporte
                        others: '', //otros
                        incidentals: '', //imprevistos
                        total: '' //total
                    }   
                },
                b: {
                    locked: true,
                    assets: { //activos
                        cash: '', //caja
                        banks: '', //bancos
                        saving_accounts: '', //cuentas de ahorros
                        accounts_receivable: '', //cuentas a cobrar
                        inventory: '', //inventario
                        others_accounts: '', //otras cuentas de ahorro corrientes
                        total_current_assets: '', //total activos corrientes
                        estate: '', //inmuebles
                        equipment: '', //muebles, maquinaria
                        vehicle: '', //vehículo
                        total_fixed_assets: '', //total activos fijos
                        others_assets: '', //otros activos
                        total_assets: '' //total activos
                    },
                    passives: { //pasivos
                        accounts_payable_suppliers: '', //cuentas por pagar a proveedores
                        banks_credits: '', //créditos bancarios
                        BMM_credits: '', //créditos BMM
                        others_obligations: '', //otras obligaciones para capital de trabajo
                        total_current_passives: '', //total pasivos corrientes
                        banks_credits_fixed_assets: '', //créditos bancarios para activo fijo
                        BMM_credits_fixed_assets: '', //créditos BMM para activo fijo
                        others_fixed_assets: '', //otras obligaciones para activo fijo
                        total_not_current_passives: '', //total pasivos no corrientes
                        total_business_passives: '', //total pasivos del negocio
                        patrimony: '', //patrimonio
                        total_passive_patrimony: '' //total pasivo y patrimonio
                    }
                },
                of: { //obligaciones financieras
                    locked: true,
                    business: { //obligaciones financieras del negocio
                        obligations:[],
                    },
                    familiar: { //obligaciones familiares
                        locked: true,
                        familiarObligations: [{
                            obligationCreditor: 'Tarjeta de crédito', //Acreedor
                            obligationAmount: '', //monto
                            obligationResidue: '', //saldo
                            obligationPaymentValue: '', //valor cuota
                            obligationTerm: 0, //plazo
                        },
                        {
                            obligationCreditor: 'Crédito consumo',
                            obligationAmount: '',
                            obligationResidue: '',
                            obligationPaymentValue: '',
                            obligationTerm: 0,
                        },
                        {
                            obligationCreditor: 'Crédito vivienda',
                            obligationAmount: '',
                            obligationResidue: '',
                            obligationPaymentValue: '',
                            obligationTerm: 0,
                        }],
                        patrimonyHouse: 0, //valor estimado casa/finca
                        patrimonyVechicle: 0 //valor estimado vehículo
                    }
                    
                    
                },
                i: { //inmuebles, equipos
                    equipment: { //equipos
                        locked: true,
                        equipment: [],
                        total: 0 //total de equipos
                    },
                    locked: true,
                    financialIndicators: [] //indicadores financieros
                },
                cp: { //capacidad de pago
                    locked: true,
                    paymentCapacity: [] 
                }
            },
            
            modelValidations: {
                indebtness: {
                    required: false
                },
                employees: {
                    required: false
                },
                sales: {
                    required: false
                },
                obligation_value: {
                    required: false
                },
                obligation_name: {
                    required: false,
                    max: 32
                },
                equipment_name: {
                    required: false,
                    max: 64
                },
                equipment_value: {
                    required: false
                }
            },
        }
    },
    computed: {
        /**
        * This function adds one to its input.
        * @param {number} input any number
        * @returns {number} that number, plus one.
        */
        incomes_others_computed: {
            get () {
                var sum = 0;
                for (let i=0;i<this.form.if.otherIncomes.length;i++) {
                    sum = sum + parseFloat(this.form.if.otherIncomes[i].incomeValue);
                }
                this.form.if.incomes.others = sum;
                return sum;
            },
            set () {

            }
        },
        /**
        * This function adds one to its input.
        * @param {number} input any number
        * @returns {number} that number, plus one.
        */
        form_estate_computed : {
            get () {
                
                var sum_estate= 0;
                for (let i=0;i<this.form.i.equipment.equipment.length;i++) {
                    if (this.form.i.equipment.equipment[i].equipmentType == '1') {
                        sum_estate = sum_estate + parseFloat(this.form.i.equipment.equipment[i].equipmentValue);
                    }
                }
                this.form.b.assets.estate = sum_estate;
                return sum_estate;
            },
            set () {

            }
        },
        /**
        * This function adds one to its input.
        * @param {number} input any number
        * @returns {number} that number, plus one.
        */
        form_equipment_computed : {
            get () {
                
                var sum_equipment= 0;
                for (let i=0;i<this.form.i.equipment.equipment.length;i++) {
                    if (this.form.i.equipment.equipment[i].equipmentType == '2') {
                        sum_equipment = sum_equipment + parseFloat(this.form.i.equipment.equipment[i].equipmentValue);
                    }
                }
                this.form.b.assets.equipment = sum_equipment;
                return sum_equipment;
            },
            set () {

            }
        },
        /**
        * This function adds one to its input.
        * @param {number} input any number
        * @returns {number} that number, plus one.
        */
        form_vehicle_computed : {
            get () {
                
                var sum_vehicle= 0;
                for (let i=0;i<this.form.i.equipment.equipment.length;i++) {
                    if (this.form.i.equipment.equipment[i].equipmentType == '3') {
                        sum_vehicle = sum_vehicle + parseFloat(this.form.i.equipment.equipment[i].equipmentValue);
                    }
                }
                this.form.b.assets.vehicle = sum_vehicle;
                return sum_vehicle;
            },
            set () {

            }
        },
        /**
        * This function adds one to its input.
        * @param {number} input any number
        * @returns {number} that number, plus one.
        */
        total_equipment_computed: {
            get () {
                var sum = 0;
                for (let i=0;i<this.form.i.equipment.equipment.length;i++) {
                    sum = sum + parseFloat(this.form.i.equipment.equipment[i].equipmentValue);
                }
                return sum;
            },
            set () {
                
            }
        },
        /**
        * This function adds one to its input.
        * @param {number} input any number
        * @returns {number} that number, plus one.
        */
        total_passive_patrimony_computed: {
            get () {
                var total = 0;
                this.form.b.passives.total_passive_patrimony = parseFloat(this.patrimony_computed) + parseFloat(this.total_business_passives_computed);
                total = this.form.b.passives.total_passive_patrimony;
                return total
            },
            set () {

            }
        },
        /**
        * This function adds one to its input.
        * @param {number} input any number
        * @returns {number} that number, plus one.
        */
        patrimony_computed: {
            get () {
                var total = 0;
                this.form.b.passives.patrimony = parseFloat(this.total_assets_computed) - parseFloat(this.total_business_passives_computed);
                total = this.form.b.passives.patrimony;
                return total
            },
            set () {

            }
        },
        /**
        * This function adds one to its input.
        * @param {number} input any number
        * @returns {number} that number, plus one.
        */
        total_business_passives_computed: {
            get () {
                var total = 0;
                this.form.b.passives.total_business_passives = parseFloat(this.total_not_current_passives_computed || 0) + parseFloat(this.total_current_passives_computed || 0);
                total = this.form.b.passives.total_business_passives;
                return total
            },
            set () {

            }
        },
        /**
        * This function adds one to its input.
        * @param {number} input any number
        * @returns {number} that number, plus one.
        */
        total_not_current_passives_computed: {
            get () {
                var total = 0;
                this.form.b.passives.total_not_current_passives = parseFloat(this.form.b.passives.banks_credits_fixed_assets || 0) + parseFloat(this.form.b.passives.BMM_credits_fixed_assets || 0) + parseFloat(this.form.b.passives.others_fixed_assets || 0);
                total = this.form.b.passives.total_not_current_passives;
                return total
            },
            set () {

            }
        },
        /**
        * This function adds one to its input.
        * @param {number} input any number
        * @returns {number} that number, plus one.
        */
        total_current_passives_computed: {
            get () {
                var total = 0;
                this.form.b.passives.total_current_passives = parseFloat(this.form.b.passives.accounts_payable_suppliers || 0) + parseFloat(this.form.b.passives.banks_credits || 0) + parseFloat(this.form.b.passives.BMM_credits || 0) + parseFloat(this.form.b.passives.others_obligations || 0);
                total = this.form.b.passives.total_current_passives;
                return total
            },
            set () {

            }
        },
        /**
        * This function adds one to its input.
        * @param {number} input any number
        * @returns {number} that number, plus one.
        */
        total_assets_computed: {
            get () {
                var total = 0;
                this.form.b.assets.total_assets = parseFloat(this.form.b.assets.others_assets || 0) + parseFloat(this.total_fixed_assets_computed || 0) + parseFloat(this.total_current_assets_computed || 0);
                total = this.form.b.assets.total_assets;
                return total
            },
            set () {

            }
        },
        /**
        * This function adds one to its input.
        * @param {number} input any number
        * @returns {number} that number, plus one.
        */
        total_fixed_assets_computed: {
            get () {
                var total = 0;
                this.form.b.assets.total_fixed_assets = parseFloat(this.form.b.assets.estate) + parseFloat(this.form.b.assets.equipment) + parseFloat(this.form.b.assets.vehicle);
                total = this.form.b.assets.total_fixed_assets;
                return total
            },
            set () {

            }
        },
        /**
        * This function adds one to its input.
        * @param {number} input any number
        * @returns {number} that number, plus one.
        */
        total_current_assets_computed: {
            get () {
                var total = 0;
                this.form.b.assets.total_current_assets = parseFloat(this.form.b.assets.cash || 0) + parseFloat(this.form.b.assets.banks || 0) + parseFloat(this.form.b.assets.saving_accounts || 0) + parseFloat(this.form.b.assets.accounts_receivable || 0) + parseFloat(this.form.b.assets.inventory || 0) + parseFloat(this.form.b.assets.others_accounts || 0);
                total = this.form.b.assets.total_current_assets;
                return total
            },
            set () {

            }
        },
        /**
        * This function adds one to its input.
        * @param {number} input any number
        * @returns {number} that number, plus one.
        */
        gross_profit_computed: {
            get () {
                var total = 0;
                this.form.er.gross_profit = parseFloat(this.form.er.account_sales) + parseFloat(this.form.er.credit_sales) - parseFloat(this.form.er.sales_costs);
                total = this.form.er.gross_profit; 
                return total;
            },
            set () {

            }
        },
        /**
        * This function adds one to its input.
        * @param {number} input any number
        * @returns {number} that number, plus one.
        */
        operative_expenses_computed: {
            get () {
                var total = 0;
                // this.form.er.operative_expenses.total = parseFloat((this.form.er.operative_expenses.salaries.value || 0) + parseFloat(this.form.er.operative_expenses.rental.value  || 0) + parseFloat(this.form.er.operative_expenses.public_services.value  || 0) + parseFloat(this.form.er.operative_expenses.taxes.value  || 0) + parseFloat(this.form.er.operative_expenses.transport.value  || 0) + parseFloat(this.form.er.operative_expenses.financial_expenses.value || 0) + parseFloat(this.form.er.operative_expenses.others.value  || 0) + parseFloat(this.form.er.operative_expenses.incidentals.value || 0).toFixed(2));
                this.form.er.operative_expenses.total = parseFloat(
                (
                    parseFloat(this.form.er.operative_expenses.salaries.value || 0) +
                    parseFloat(this.form.er.operative_expenses.rental.value || 0) +
                    parseFloat(this.form.er.operative_expenses.public_services.value || 0) +
                    parseFloat(this.form.er.operative_expenses.taxes.value || 0) +
                    parseFloat(this.form.er.operative_expenses.transport.value || 0) +
                    parseFloat(this.form.er.operative_expenses.financial_expenses.value || 0) +
                    parseFloat(this.form.er.operative_expenses.others.value || 0) +
                    parseFloat(this.form.er.operative_expenses.incidentals.value || 0)
                ).toFixed(1) // Redondea a 2 decimales y devuelve un string
                );
                var total = this.form.er.operative_expenses.total;
                return total;
            },
            set () {

            }
        },
        /**
        * This function adds one to its input.
        * @param {number} input any number
        * @returns {number} that number, plus one.
        */
        net_profit_computed: {
            get () {
                var total = 0;
                this.form.er.net_profit = parseFloat(this.gross_profit_computed) - parseFloat(this.operative_expenses_computed);
                this.form.if.incomes.business_income = this.form.er.net_profit;
                total = this.form.er.net_profit;
                return total;
            },
            set () {

            }
        },
        /**
        * This function adds one to its input.
        * @param {number} input any number
        * @returns {number} that number, plus one.
        */
        family_income_computed: {
            get () {
                var total = 0;
                this.form.if.incomes.total = parseFloat(this.form.if.incomes.business_income || 0) + parseFloat(this.form.if.incomes.titular_salary || 0) + parseFloat(this.form.if.incomes.spouse_salary || 0) + parseFloat(this.form.if.incomes.others || 0); 
                total = this.form.if.incomes.total;
                return total;
            },
            set () {

            }
        },
        /**
        * This function adds one to its input.
        * @param {number} input any number
        * @returns {number} that number, plus one.
        */
        family_expenses_incidentals_computed: {
            get () {
                var total = 0;
                this.form.if.expenses.incidentals = parseFloat(this.family_income_computed) * 10 / 100;
                total = this.form.if.expenses.incidentals;
                return total;
            },
            set () {

            }
        },
        /**
        * This function adds one to its input.
        * @param {number} input any number
        * @returns {number} that number, plus one.
        */
        family_expenses_computed: {
            get () {
                var total = 0;
                this.form.if.expenses.total = parseFloat(this.form.if.expenses.rental || 0) + parseFloat(this.form.if.expenses.feeding || 0) + parseFloat(this.form.if.expenses.public_services || 0) + parseFloat(this.form.if.expenses.education || 0) + parseFloat(this.form.if.expenses.health || 0) + parseFloat(this.form.if.expenses.credits || 0) + parseFloat(this.form.if.expenses.transport || 0) + parseFloat(this.form.if.expenses.others || 0) + parseFloat(this.form.if.expenses.incidentals || 0);
                total = this.form.if.expenses.total;
                return total;
            },
            set () {

            }
        },
        /**
        * This function adds one to its input.
        * @param {number} input any number
        * @returns {number} that number, plus one.
        */
        family_surplus_computed: {
            get () {
                var total = 0;
                this.form.if.surplus = parseFloat(this.family_income_computed || 0) - parseFloat(this.family_expenses_computed || 0);
                total = this.form.if.surplus;
                return total;
            },
            set () {

            }
        },
        /**
        * This function adds one to its input.
        * @param {number} input any number
        * @returns {number} that number, plus one.
        */
        payment_capacity_computed: {
            get () {
                for (let i=0;i<this.form.cp.paymentCapacity.length;i++) {
                    if(this.$store.state.isCustomer) {
                        // var evalResult = 0;
                        // evalResult = this.setPaymentEval(this.form.cp.paymentCapacity[i].id);
                        if (this.form.cp.paymentCapacity[i].id == 1) {
                            this.form.cp.paymentCapacity[i].value = this.family_income_computed * 30 / 100;
                        }
                        else if(this.form.cp.paymentCapacity[i].id == 2) {
                            this.form.cp.paymentCapacity[i].value = this.family_surplus_computed * 50 / 100;
                        }
                        else if(this.form.cp.paymentCapacity[i].id == 3) {
                            // this.form.cp.paymentCapacity[i].value = this.family_income_computed * 40 / 100;
                            this.form.cp.paymentCapacity[i].value = this.form.if.incomes.titular_salary * 40 / 100; 
                        }
                        else if(this.form.cp.paymentCapacity[i].id == 4){
                            var a = this.family_income_computed * 30 / 100;
                            var b = this.family_surplus_computed * 50 / 100;
                            var c = this.form.if.incomes.titular_salary * 40 / 100;
                            var arrayComputed = [a, b, c];
                            var minimum = Math.min(...arrayComputed);
                            this.form.cp.paymentCapacity[i].value = minimum;
                        }
                    }
                    else {
                        this.form.cp.paymentCapacity[i].value = 0;
                    }
                }
                return this.form.cp.paymentCapacity;
            },
            set () {

            }
        }
    },
    watch: {
        /**
        * This function adds one to its input.
        * @param {number} input any number
        * @returns {number} that number, plus one.
        */
        'form.er.employees': function (newVal) {
            this.form.er.employees =  parseFloat(newVal)
        },
        /**
        * This function adds one to its input.
        * @param {number} input any number
        * @returns {number} that number, plus one.
        */
        'form.debt.cial': function (newVal, oldVal) {
            if (newVal) {
                this.form.debt.mc = false;
            }
        },
        /**
        * This function adds one to its input.
        * @param {number} input any number
        * @returns {number} that number, plus one.
        */
        'form.debt.mc': function (newVal, oldVal) {
            if (newVal) {
                this.form.debt.cial = false;
            }
        },
        },
    methods:{
        /**
         * This function adds one to its input.
         * @param {number} input any number
         * @returns {number} that number, plus one.
         */
        productValidator (product) {
            if (product.name.toLowerCase() == 'consumo') {
                this.consumer = true;
                this.microcredit = false;
            }
            else if (product.name.toLowerCase() == 'microcrédito' || product.name.toLowerCase() == 'microcredito') {
                this.microcredit = true;
                this.consumer = false;
            }
            else {
                this.showNotificationError('Este tipo de producto aún no es implementado en EMI');
            }
        },
        /**
        * This function adds one to its input.
        * @param {number} input any number
        * @returns {number} that number, plus one.
        */
        otherIncomesFocus(){
            var vm = this;
            let promise = new Promise(function(resolve, reject) {
                vm.incomeType = '1';
                vm.addIncomesMethod();
                resolve();
            }).then(function(resolve){
                document.getElementById("otherIncomes").blur();
                // vm.$refs.refIncomes.$el.children[0].focus()
            });
        },
        /**
        * This function adds one to its input.
        * @param {number} input any number
        * @returns {number} that number, plus one.
        */
        equipmentFocus(index){
            var vm = this;
            if(vm.form.i.equipment.equipment.length < 5) {
                let promise = new Promise(function(resolve, reject) {
                    vm.equipmentType = index.toString();
                    vm.addEquipmentMethod();
                    resolve();
                }).then(function(resolve){
                    vm.$refs.refEquipment.$el.children[0].focus()
                });
            }
            else {
                this.showNotificationError('El máximo número de de inmuebles, maquinaria y equipo es 5');
            }
        },
        /**
        * This function adds one to its input.
        * @param {number} input any number
        * @returns {number} that number, plus one.
        */
        validateOperatingExpensesDisabled (val) {
            if (val == 0) {
                return false
            }
            else {
                return true
            }
        },
        /**
        * This function adds one to its input.
        * @param {number} input any number
        * @returns {number} that number, plus one.
        */
        validateStudy () {
            if (this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy == 0) {
                return true
            }
            else {
                return false
            }
        },
        /**
        * This function adds one to its input.
        * @param {number} input any number
        * @returns {number} that number, plus one.
        */
        cancelHelp () {
            this.showHelp = false;
            this.helpText = null;
        },
        /**
        * This function adds one to its input.
        * @param {number} input any number
        * @returns {number} that number, plus one.
        */
        showHelpMethod (row) {
            this.helpText = row.info;
            this.showHelp = true;
        },
        /**
        * This function adds one to its input.
        * @param {number} input any number
        * @returns {number} that number, plus one.
        */
        setPaymentEval (id) {
            switch (id) {
            case 1:
                return this.form.er.net_profit;
                break;
            case 2: 
                if (this.form.if.incomes.business_income != this.form.if.incomes.total) { return (this.form.if.incomes.business_income / this.form.if.incomes.total) * this.form.if.expenses.total } else { return this.form.if.expenses.total }
                break;
            case 3: 
                var operation = 0; if (this.form.if.incomes.business_income != this.form.if.incomes.total) { operation = (this.form.if.incomes.business_income / this.form.if.incomes.total) * this.form.if.expenses.total } else { operation = this.form.if.expenses.total }; return this.form.er.net_profit - operation;
                break; 
            case 4:
                var operation = 0; if (this.form.if.incomes.business_income != this.form.if.incomes.total) { operation = (this.form.if.incomes.business_income / this.form.if.incomes.total) * this.form.if.expenses.total } else { operation = this.form.if.expenses.total }; return (this.form.er.net_profit - operation)*0.6;
                break;
            default:
                console.log('default');
            }
        },
        /**
        * This function adds one to its input.
        * @param {number} input any number
        * @returns {number} that number, plus one.
        */
        setEval (str) {
            const ast = expr.parse(str);
            return expr.eval(ast, this.$data)
        },
        /**
        * This function adds one to its input.
        * @param {number} input any number
        * @returns {number} that number, plus one.
        */
        setSuffix (row) {
            if (isNaN(row.value) || row.value == 'Infinity') {
                return 'Revisa los valores'
            }
            else {
                if (row.unit == '$') {
                    return this.setFormat(row.value);
                }
                else {
                    return [row.value,' ',row.unit].join('');
                }
            }
            
        },
        /**
        * This function adds one to its input.
        * @param {number} input any number
        * @returns {number} that number, plus one.
        */
        tableRowClassName({row, rowIndex}) {
            if (row.formula != null && this.modifiedFinancialIndicators) {
                let result = this.setEval(row.formula);
                this.form.i.financialIndicators[rowIndex].value = Number((result).toFixed(2));
                let finalFormula = [result,' ',row.alert].join('')
                if(this.setEval(finalFormula) == true || isNaN(result) || result == 'Infinity') {
                    return 'warning-row';        
                }
                else {
                    return '';
                }
                return ''
            }
        },
        /**
        * This function adds one to its input.
        * @param {number} input any number
        * @returns {number} that number, plus one.
        */
        tableRowClassName2({row, rowIndex}) {
            if (row.name == 'Capacidad de pago (60%)') {
                return 'capacity-row';
            }
            else {
                return ''
            }
        },
        /**
        * This function adds one to its input.
        * @param {number} input any number
        * @returns {number} that number, plus one.
        */
        showNotificationError (message) {
            this.$notify(
            {
                message: message,
                icon: 'nc-icon nc-glasses-2',
                horizontalAlign: 'center',
                verticalAlign: 'top',
                type: 'danger'
            })
        },
        /**
        * This function adds one to its input.
        * @param {number} input any number
        * @returns {number} that number, plus one.
        */
        showEngineRulesNotificationError (message) {
            this.$notify(
            {
                message: message,
                icon: 'nc-icon nc-glasses-2',
                horizontalAlign: 'center',
                verticalAlign: 'top',
                type: 'danger'
            })
        },
        /**
        * This function adds one to its input.
        * @param {number} input any number
        * @returns {number} that number, plus one.
        */
        showNotificationSuccess (message) {
            this.$notify(
            {
                message: message,
                icon: 'nc-icon nc-check-2',
                horizontalAlign: 'center',
                verticalAlign: 'top',
                type: 'success'
            })
        },
        /**
        * This function adds one to its input.
        * @param {number} input any number
        * @returns {number} that number, plus one.
        */
        handleCurrentObligationChange(currentRow, oldCurrentRow) {
                this.currentObligationRow = currentRow;
        },
        /**
        * This function adds one to its input.
        * @param {number} input any number
        * @returns {number} that number, plus one.
        */
        handleCurrentEquipmentChange(currentRow, oldCurrentRow) {
                this.currentEquipmentRow = currentRow;
        },
        /**
        * This function adds one to its input.
        * @param {number} input any number
        * @returns {number} that number, plus one.
        */
        handleCurrentIncomesChange(currentRow, oldCurrentRow) {
                this.currentIncomesRow = currentRow;
        },
        /**
        * This function adds one to its input.
        * @param {number} input any number
        * @returns {number} that number, plus one.
        */
        handleCurrentFamiliarObligationChange(currentRow, oldCurrentRow) {
                this.currentFamiliarObligationRow = currentRow;
        },
        /**
        * This function adds one to its input.
        * @param {number} input any number
        * @returns {number} that number, plus one.
        */
        cancelAddObligation () {
            this.addObligation = false;
        },
        /**
        * This function adds one to its input.
        * @param {number} input any number
        * @returns {number} that number, plus one.
        */
        cancelAddEquipment () {
            this.resetEquipment();
            this.addEquipment = false;
        },
        /**
        * This function adds one to its input.
        * @param {number} input any number
        * @returns {number} that number, plus one.
        */
        cancelAddIncomes () {
            this.resetIncomes();
            this.addIncomes = false;
        },
        /**
        * This function adds one to its input.
        * @param {number} input any number
        * @returns {number} that number, plus one.
        */
        addObligationToList () {
            this.$validator.validateAll().then(isValid => {
                if(isValid){
                    if (this.obligationCreditor == '' || this.obligationAmount == '' || this.obligationPaymentValue == '' || this.obligationNumberPayments == '' || this.obligationTerm == '') {
                        this.showNotificationError('Revisa y completa el formulario');
                    }
                    else {
                        this.form.of.business.obligations.push({
                            obligationCreditor:  this.obligationCreditor,
                            obligationAmount: this.obligationAmount,
                            obligationPaymentValue: this.obligationPaymentValue,
                            obligationNumberPayments: this.obligationNumberPayments,
                            obligationTerm: this.obligationTerm,
                        })
                        this.resetObligation();
                        this.addObligation = false;
                        this.showNotificationSuccess('Obligación creada correctamente');
                    }
                }
            })
        },
        /**
        * This function adds one to its input.
        * @param {number} input any number
        * @returns {number} that number, plus one.
        */
        addEquipmentToList () {
            this.$validator.validateAll().then(isValid => {
                if(isValid){
                    if (this.equipmentDescription == '' || this.equipmentValue == '') {
                        this.showNotificationError('Revisa y completa el formulario');
                    }
                    else {
                        this.form.i.equipment.equipment.push({
                            equipmentDescription:  this.equipmentDescription,
                            equipmentValue: this.equipmentValue,
                            equipmentType: this.equipmentType,
                        })
                        this.resetEquipment();
                        this.addEquipment = false;
                        this.showNotificationSuccess('Ítem agregado correctamente');
                    }
                }
            })
        },
        /**
        * This function adds one to its input.
        * @param {number} input any number
        * @returns {number} that number, plus one.
        */
        addIncomesToList () {
            this.$validator.validateAll().then(isValid => {
                if(isValid){
                    if (this.incomeValue == '') {
                        this.showNotificationError('Revisa y completa el formulario');
                    }
                    else {
                        this.form.if.otherIncomes.push({
                            incomeValue: this.incomeValue,
                            incomeType: this.incomeType,
                        })
                        this.resetIncomes();
                        this.addIncomes = false;
                        this.showNotificationSuccess('Ingreso neto agregado correctamente');
                    }
                }
            })
        },
        /**
        * This function adds one to its input.
        * @param {number} input any number
        * @returns {number} that number, plus one.
        */
        resetObligation () {
            this.obligationCreditor = '';
            this.obligationAmount = '';
            this.obligationPaymentValue = '';
            this.obligationNumberPayments = '';
            this.obligationTerm = '';
        },
        /**
        * This function adds one to its input.
        * @param {number} input any number
        * @returns {number} that number, plus one.
        */
        resetEquipment () {
            this.equipmentDescription = '';
            this.equipmentType = '1';
            this.equipmentValue = '';
        },
        /**
        * This function adds one to its input.
        * @param {number} input any number
        * @returns {number} that number, plus one.
        */
        resetIncomes () {
            this.incomeType = '1';
            this.incomeValue = '';
        },
        /**
        * This function adds one to its input.
        * @param {number} input any number
        * @returns {number} that number, plus one.
        */
        cancelEditObligation () {
            this.editObligation = false;
        },
        /**
        * This function adds one to its input.
        * @param {number} input any number
        * @returns {number} that number, plus one.
        */
        cancelEditEquipment () {
            this.editEquipment = false;
        },
        /**
        * This function adds one to its input.
        * @param {number} input any number
        * @returns {number} that number, plus one.
        */
        cancelEditIncomes () {
            this.editIncomes = false;
        },
        /**
        * This function adds one to its input.
        * @param {number} input any number
        * @returns {number} that number, plus one.
        */
        cancelEditFamiliarObligation () {
            this.editFamiliarObligation = false;
        },
        /**
        * This function adds one to its input.
        * @param {number} input any number
        * @returns {number} that number, plus one.
        */
        editObligationToList () {
            this.$validator.validateAll().then(isValid => {
                if(isValid){
                    if (this.obligationCreditor == '' || this.obligationAmount == '' || this.obligationPaymentValue == '' || this.obligationNumberPayments == '' || this.obligationTerm == '') {
                        this.showNotificationError('Revisa y completa el formulario');
                    }
                    else {
                        var index = this.form.of.business.obligations.indexOf(this.currentObligationRow);
                        this.form.of.business.obligations[index].obligationCreditor = this.obligationCreditor;
                        this.form.of.business.obligations[index].obligationAmount = this.obligationAmount;
                        this.form.of.business.obligations[index].obligationPaymentValue = this.obligationPaymentValue;
                        this.form.of.business.obligations[index].obligationNumberPayments = this.obligationNumberPayments;
                        this.form.of.business.obligations[index].obligationTerm = this.obligationTerm;
                        this.resetObligation();
                        this.$refs.obligationsTable.setCurrentRow();
                        this.editObligation = false;
                        this.showNotificationSuccess('Obligación editada correctamente');
                    }
                }
            })
        },
        /**
        * This function adds one to its input.
        * @param {number} input any number
        * @returns {number} that number, plus one.
        */
        editEquipmentToList () {
            this.$validator.validateAll().then(isValid => {
                if(isValid){
                    if (this.equipmentDescription == '' || this.equipmentValue == '') {
                        this.showNotificationError('Revisa y completa el formulario');
                    }
                    else {
                        var index = this.form.i.equipment.equipment.indexOf(this.currentEquipmentRow);
                        this.form.i.equipment.equipment[index].equipmentDescription = this.equipmentDescription;
                        this.form.i.equipment.equipment[index].equipmentType = this.equipmentType;
                        this.form.i.equipment.equipment[index].equipmentValue = this.equipmentValue;
                        this.resetEquipment();
                        this.$refs.equipmentsTable.setCurrentRow();
                        this.editEquipment = false;
                        this.showNotificationSuccess('Obligación editada correctamente');
                    }
                }
            })
        },
        /**
        * This function adds one to its input.
        * @param {number} input any number
        * @returns {number} that number, plus one.
        */
        editIncomesToList () {
            this.$validator.validateAll().then(isValid => {
                if(isValid){
                    if (this.incomeValue == '') {
                        this.showNotificationError('Revisa y completa el formulario');
                    }
                    else {
                        var index = this.form.if.otherIncomes.indexOf(this.currentIncomesRow);
                        this.form.if.otherIncomes[index].incomeType = this.incomeType;
                        this.form.if.otherIncomes[index].incomeValue = this.incomeValue;
                        this.resetIncomes();
                        this.$refs.incomesTable.setCurrentRow();
                        this.editIncomes = false;
                        this.showNotificationSuccess('Ingreso neto editado correctamente');
                    }
                }
            })
        },
        /**
        * This function adds one to its input.
        * @param {number} input any number
        * @returns {number} that number, plus one.
        */
        editFamiliarObligationToList () {
            this.$validator.validateAll().then(isValid => {
                if(isValid){
                    if (this.familiarObligationCreditor == '' || this.familiarObligationAmount == '' || this.familiarObligationResidue == '') {
                        var index = this.form.of.familiar.familiarObligations.indexOf(this.currentFamiliarObligationRow);
                        this.form.of.familiar.familiarObligations[index].obligationCreditor = this.familiarObligationCreditor;
                        this.form.of.familiar.familiarObligations[index].obligationAmount = 0;
                        this.form.of.familiar.familiarObligations[index].obligationPaymentValue = 0;
                        this.form.of.familiar.familiarObligations[index].obligationResidue = 0;
                        this.form.of.familiar.familiarObligations[index].obligationTerm = 0;
                        this.$refs.familiarObligationsTable.setCurrentRow();
                        this.editFamiliarObligation = false;
                        this.showNotificationSuccess('Obligación familiar editada correctamente');
                    }
                    else {
                        // if(this.familiarObligationResidue > this.familiarObligationAmount) {
                        //     this.showNotificationError('El saldo no puede ser mayor al monto');
                        //     return
                        // }
                        var index = this.form.of.familiar.familiarObligations.indexOf(this.currentFamiliarObligationRow);
                        this.form.of.familiar.familiarObligations[index].obligationCreditor = this.familiarObligationCreditor;
                        this.form.of.familiar.familiarObligations[index].obligationAmount = this.familiarObligationAmount;
                        this.form.of.familiar.familiarObligations[index].obligationPaymentValue = this.familiarObligationPaymentValue;
                        this.form.of.familiar.familiarObligations[index].obligationResidue = this.familiarObligationResidue;
                        this.form.of.familiar.familiarObligations[index].obligationTerm = this.familiarObligationTerm;
                        this.$refs.familiarObligationsTable.setCurrentRow();
                        this.editFamiliarObligation = false;
                        this.showNotificationSuccess('Obligación familiar editada correctamente');
                    }
                }
            })
        },
        /**
        * This function adds one to its input.
        * @param {number} input any number
        * @returns {number} that number, plus one.
        */
        addObligationMethod () {
            this.addObligation = true;
        },
        /**
        * This function adds one to its input.
        * @param {number} input any number
        * @returns {number} that number, plus one.
        */
        addEquipmentMethod () {
            if(this.form.i.equipment.equipment.length < 5) {
                this.addEquipment = true;
            }
            else {
                this.showNotificationError('El máximo número de de inmuebles, maquinaria y equipo es 5');
            }
        },
        /**
        * This function adds one to its input.
        * @param {number} input any number
        * @returns {number} that number, plus one.
        */
        addIncomesMethod () {
            this.addIncomes = true;
        },
        /**
        * This function adds one to its input.
        * @param {number} input any number
        * @returns {number} that number, plus one.
        */
        editObligationMethod () {
            var index = this.form.of.business.obligations.indexOf(this.currentObligationRow);
            this.obligationCreditor = this.form.of.business.obligations[index].obligationCreditor;
            this.obligationAmount = this.form.of.business.obligations[index].obligationAmount;
            this.obligationPaymentValue = this.form.of.business.obligations[index].obligationPaymentValue;
            this.obligationNumberPayments = this.form.of.business.obligations[index].obligationNumberPayments;
            this.obligationTerm = this.form.of.business.obligations[index].obligationTerm;
            this.editObligation = true;
        },
        /**
        * This function adds one to its input.
        * @param {number} input any number
        * @returns {number} that number, plus one.
        */
        editEquipmentMethod () {
            var index = this.form.i.equipment.equipment.indexOf(this.currentEquipmentRow);
            this.equipmentDescription = this.form.i.equipment.equipment[index].equipmentDescription;
            this.equipmentValue = this.form.i.equipment.equipment[index].equipmentValue;
            this.equipmentType = this.form.i.equipment.equipment[index].equipmentType;
            this.editEquipment = true;
        },
        /**
        * This function adds one to its input.
        * @param {number} input any number
        * @returns {number} that number, plus one.
        */
        editIncomesMethod () {
            var index = this.form.if.otherIncomes.indexOf(this.currentIncomesRow);
            if (this.form.if.otherIncomes[index].incomeType != "2") {
                this.incomeValue = this.form.if.otherIncomes[index].incomeValue;
                this.incomeType = this.form.if.otherIncomes[index].incomeType;
                this.editIncomes = true;
            }
            else {
                this.showNotificationError('Los ingresos microempresariales no pueden ser editados')
            }
            
        },
        /**
        * This function adds one to its input.
        * @param {number} input any number
        * @returns {number} that number, plus one.
        */
        editFamiliarObligationMethod () {
            var index = this.form.of.familiar.familiarObligations.indexOf(this.currentFamiliarObligationRow);
            this.familiarObligationCreditor = this.form.of.familiar.familiarObligations[index].obligationCreditor;
            this.familiarObligationAmount = this.form.of.familiar.familiarObligations[index].obligationAmount;
            this.familiarObligationPaymentValue = this.form.of.familiar.familiarObligations[index].obligationPaymentValue;
            this.familiarObligationResidue = this.form.of.familiar.familiarObligations[index].obligationResidue;
            this.familiarObligationTerm = this.form.of.familiar.familiarObligations[index].obligationTerm;
            this.editFamiliarObligation = true;
        },
        /**
        * This function adds one to its input.
        * @param {number} input any number
        * @returns {number} that number, plus one.
        */
        removeObligationMethod () {
            this.form.of.business.obligations.splice(this.form.of.business.obligations.indexOf(this.currentObligationRow),1);
            this.currentObligationRow = null;
        },
        /**
        * This function adds one to its input.
        * @param {number} input any number
        * @returns {number} that number, plus one.
        */
        removeEquipmentMethod () {
            this.form.i.equipment.equipment.splice(this.form.i.equipment.equipment.indexOf(this.currentEquipmentRow),1);
            this.currentEquipmentRow = null;
        },
        /**
        * This function adds one to its input.
        * @param {number} input any number
        * @returns {number} that number, plus one.
        */
        removeIncomesMethod () {
            this.form.if.otherIncomes.splice(this.form.if.otherIncomes.indexOf(this.currentIncomesRow),1);
            this.currentIncomesRow = null;
        },
        /**
        * This function adds one to its input.
        * @param {number} input any number
        * @returns {number} that number, plus one.
        */
        setFormat (value) {
            return formatMoney(value, { symbol: "$", precision: 0, thousand: ".", decimal: "," });
        },
        /**
        * This function adds one to its input.
        * @param {number} input any number
        * @returns {number} that number, plus one.
        */
        setIncomeType (value) {
            if (value == '1') {
                return 'Bonificaciones y comisiones'
            }
            else if (value == '2') {
                return 'Microempresariales'
            }
            else if (value == '3') {
                return 'Otros'
            }
        },
        /**
        * This function adds one to its input.
        * @param {number} input any number
        * @returns {number} that number, plus one.
        */
        toER () {
            VueScrollTo.scrollTo('#toERElement')
        },
        /**
        * This function adds one to its input.
        * @param {number} input any number
        * @returns {number} that number, plus one.
        */
        toIF () {
            VueScrollTo.scrollTo('#toIFElement')
        },
        /**
        * This function adds one to its input.
        * @param {number} input any number
        * @returns {number} that number, plus one.
        */
        toB () {
            VueScrollTo.scrollTo('#toBElement')
        },
        /**
        * This function adds one to its input.
        * @param {number} input any number
        * @returns {number} that number, plus one.
        */
        toOF () {
            VueScrollTo.scrollTo('#toOFElement')
        },
        /**
        * This function adds one to its input.
        * @param {number} input any number
        * @returns {number} that number, plus one.
        */
        toOFU () {
            VueScrollTo.scrollTo('#toOFUElement')
        },
        /**
        * This function adds one to its input.
        * @param {number} input any number
        * @returns {number} that number, plus one.
        */
        toI () {
            VueScrollTo.scrollTo('#toIElement')
        },
        /**
        * This function adds one to its input.
        * @param {number} input any number
        * @returns {number} that number, plus one.
        */
        toCP () {
            VueScrollTo.scrollTo('#toCPElement')
        },
        /**
        * This function adds one to its input.
        * @param {number} input any number
        * @returns {number} that number, plus one.
        */
        toIFI () {
            VueScrollTo.scrollTo('#toIFIElement')
        },
        /**
        * This function adds one to its input.
        * @param {number} input any number
        * @returns {number} that number, plus one.
        */
        toBusinessReferences () {
            this.$router.push('/asessments/new_asessment/customer/others/business_references');
        },
        /**
        * This function adds one to its input.
        * @param {number} input any number
        * @returns {number} that number, plus one.
        */
        getError (fieldName) {
            return this.errors.first(fieldName)
        },
        /**
        * This function adds one to its input.
        * @param {number} input any number
        * @returns {number} that number, plus one.
        */
        validateForm(scope) {
            this.$validator.validateAll(scope).then(result => {
                if (result) {
                    if (scope == 'formER') {
                        var vm = this;
                        if (vm.$store.state.isCustomer) {
                            if (vm.$store.state.assesments[vm.$store.state.actualAssesment].customer.actualStudy == 0) {
                                let promise = new Promise(function(resolve, reject) {
                                    vm.$store.dispatch('setBalance', vm.$data).then(()=>{
                                        vm.form.if.locked = false;
                                        resolve();
                                    });
                                }).then(function(resolve){
                                    if(!vm.fabActions.filter(element=> element.name == 'toIF').length > 0) {
                                        vm.fabActions.push({
                                            name: 'toIF',
                                            icon: 'IF'
                                        })
                                    }
                                    vm.toIF();
                                });
                            }
                            else {
                                let promise = new Promise(function(resolve, reject) {
                                    vm.form.if.incomes.business_income= 0;
                                    vm.form.if.incomes.titular_salary= 0;
                                    vm.form.if.incomes.spouse_salary= 0;
                                    vm.form.if.incomes.others= 0;
                                    vm.form.if.incomes.total= 0;
                                    vm.form.if.expenses.rental= 0;
                                    vm.form.if.expenses.feeding= 0;
                                    vm.form.if.expenses.public_services= 0;
                                    vm.form.if.expenses.education= 0;
                                    vm.form.if.expenses.health= 0;
                                    vm.form.if.expenses.credits= 0;
                                    vm.form.if.expenses.transport= 0;
                                    vm.form.if.expenses.others= 0;
                                    vm.form.if.expenses.incidentals= 0;
                                    vm.form.if.expenses.total= 0;
                                    vm.form.b.locked = false;
                                    vm.form.i.equipment.locked = false;
                                    vm.$store.dispatch('setBalance', vm.$data).then(()=>{
                                        resolve();
                                    });
                                }).then(function(resolve){
                                    if(!vm.fabActions.filter(element=> element.name == 'toB').length > 0) {
                                        vm.fabActions.push({
                                            name: 'toB',
                                            icon: 'B'
                                        }
                                        ,
                                        {
                                            name: 'toI',
                                            icon: 'I'
                                        }
                                        )
                                    }
                                    vm.toB();
                                });
                            }
                        }
                        else if (vm.$store.state.isGuarantor) {
                            if (vm.$store.state.assesments[vm.$store.state.actualAssesment].guarantors[vm.$store.state.assesments[vm.$store.state.actualAssesment].actualGuarantors].studies.length - 1 == 0) {
                                let promise = new Promise(function(resolve, reject) {
                                    vm.$store.dispatch('setBalance', vm.$data).then(()=>{
                                        vm.form.if.locked = false;
                                        resolve();
                                    });
                                }).then(function(resolve){
                                    if(!vm.fabActions.filter(element=> element.name == 'toIF').length > 0) {
                                        vm.fabActions.push({
                                            name: 'toIF',
                                            icon: 'IF'
                                        })
                                    }
                                    vm.toIF();
                                });
                            }
                            else {
                                let promise = new Promise(function(resolve, reject) {
                                    vm.form.if.incomes.business_income= 0;
                                    vm.form.if.incomes.titular_salary= 0;
                                    vm.form.if.incomes.spouse_salary= 0;
                                    vm.form.if.incomes.others= 0;
                                    vm.form.if.incomes.total= 0;
                                    vm.form.if.expenses.rental= 0;
                                    vm.form.if.expenses.feeding= 0;
                                    vm.form.if.expenses.public_services= 0;
                                    vm.form.if.expenses.education= 0;
                                    vm.form.if.expenses.health= 0;
                                    vm.form.if.expenses.credits= 0;
                                    vm.form.if.expenses.transport= 0;
                                    vm.form.if.expenses.others= 0;
                                    vm.form.if.expenses.incidentals= 0;
                                    vm.form.if.expenses.total= 0;
                                    vm.form.b.locked = false;
                                    vm.form.i.equipment.locked = false;
                                    vm.$store.dispatch('setBalance', vm.$data).then(()=>{
                                        resolve();
                                    });
                                }).then(function(resolve){
                                    if(!vm.fabActions.filter(element=> element.name == 'toB').length > 0) {
                                        vm.fabActions.push({
                                            name: 'toB',
                                            icon: 'B'
                                        }
                                        ,
                                        {
                                            name: 'toI',
                                            icon: 'I'
                                        }
                                        )
                                    }
                                    vm.toB();
                                });
                            }
                        }
                        
                    }
                    else if (scope == 'formIF') {
                        var vm = this;
                        if(vm.$store.state.isSpouse) {
                            for (let i=0;i<vm.form.i.financialIndicators.length;i++) {
                                var assign_var = 0;
                                vm.form.i.financialIndicators[i].value = assign_var;
                            }
                            vm.$store.dispatch('setBalance', vm.$data).then(()=>{
                                var payload = {
                                    stage: 'Registro de balance',
                                    description: 'Se ingresan todos los datos del balance del cónyuge en consumo.',
                                    dateTime: moment().format()
                                };
                                vm.$store.dispatch('setChangeLog', payload).then(()=>{
                                    vm.$router.push('/asessments/new_asessment/customer/others/character_analysis');
                                });
                            });
                            return
                        }
                        
                        let promise = new Promise(function(resolve, reject) {
                            vm.$store.dispatch('setBalance', vm.$data).then(()=>{
                                vm.form.b.locked = false;
                                vm.form.i.equipment.locked = false;
                                resolve();
                            });
                        }).then(function(resolve){
                            if(!vm.fabActions.filter(element=> element.name == 'toB').length > 0) {
                                vm.fabActions.push({
                                    name: 'toB',
                                    icon: 'B'
                                },
                                {
                                    name: 'toI',
                                    icon: 'I'
                                }
                                )
                            }
                            vm.toB();
                        });
                    }
                    else if (scope == 'formB') {
                        var vm = this;
                        // if (parseFloat(vm.$store.state.assesments[vm.$store.state.actualAssesment].amount) > parseFloat(vm.form.b.passives.patrimony)) {
                        //     vm.showEngineRulesNotificationError('El monto solicitado es mayor al tamaño del negocio.');
                        // }
                        let promise = new Promise(function(resolve, reject) {
                            vm.$store.dispatch('setBalance', vm.$data).then(()=>{
                                if (vm.$store.state.isCustomer) {
                                    if (vm.$store.state.assesments[vm.$store.state.actualAssesment].customer.actualStudy == 0) {
                                        vm.form.of.locked = false;
                                        vm.form.of.familiar.locked = false;
                                    }
                                    else {
                                        vm.form.of.locked = false;
                                    }
                                    resolve();
                                }
                                else if (vm.$store.state.isGuarantor) {
                                    if (vm.$store.state.assesments[vm.$store.state.actualAssesment].guarantors[vm.$store.state.assesments[vm.$store.state.actualAssesment].actualGuarantors].studies.length - 1 == 0) {
                                        vm.form.of.locked = false;
                                        vm.form.of.familiar.locked = false;
                                    }
                                    else {
                                        vm.form.of.locked = false;
                                    }
                                    resolve();
                                }
                            });
                        }).then(function(resolve){
                            if(!vm.fabActions.filter(element=> element.name == 'toOF').length > 0) {
                                if (vm.$store.state.isCustomer) {
                                    if (vm.$store.state.assesments[vm.$store.state.actualAssesment].customer.actualStudy == 0) {
                                        vm.fabActions.push({
                                            name: 'toOF',
                                            icon: 'OF'
                                        },
                                        {
                                            name: 'toOFU',
                                            icon: 'OFU'
                                        })
                                    }
                                    else {
                                        vm.fabActions.push({
                                            name: 'toOF',
                                            icon: 'OF'
                                        })
                                    }
                                }
                                else if (vm.$store.state.isGuarantor) {
                                    if (vm.$store.state.assesments[vm.$store.state.actualAssesment].guarantors[vm.$store.state.assesments[vm.$store.state.actualAssesment].actualGuarantors].studies.length - 1 == 0) {
                                        vm.fabActions.push({
                                            name: 'toOF',
                                            icon: 'OF'
                                        },
                                        {
                                            name: 'toOFU',
                                            icon: 'OFU'
                                        })
                                    }
                                    else {
                                        vm.fabActions.push({
                                            name: 'toOF',
                                            icon: 'OF'
                                        })
                                    }
                                }
                            }
                            vm.toOF();
                        });
                    }
                    else if (scope == 'formOF') {
                        var vm = this;
                        if(vm.$store.state.isCustomer) {
                            if (vm.$store.state.assesments[vm.$store.state.actualAssesment].customer.actualStudy == 0) {
                                let promise = new Promise(function(resolve, reject) {
                                    vm.$store.dispatch('setBalance', vm.$data).then(()=>{
                                        vm.form.of.familiar.locked = false;
                                        resolve();
                                    });
                                }).then(function(resolve){
                                    if(!vm.fabActions.filter(element=> element.name == 'toOFU').length > 0) {
                                        vm.fabActions.push({
                                            name: 'toOFU',
                                            icon: 'OFU'
                                        })
                                    }
                                    vm.toOFU();
                                });
                            }
                            else {
                                let promise = new Promise(function(resolve, reject) {
                                    vm.form.of.familiar.familiarObligations[0].obligationAmount = 0;
                                    vm.form.of.familiar.familiarObligations[0].obligationResidue = 0;
                                    vm.form.of.familiar.familiarObligations[0].obligationPaymentValue = 0;
                                    vm.form.of.familiar.familiarObligations[1].obligationAmount = 0;
                                    vm.form.of.familiar.familiarObligations[1].obligationResidue = 0;
                                    vm.form.of.familiar.familiarObligations[1].obligationPaymentValue = 0;
                                    vm.form.of.familiar.familiarObligations[2].obligationAmount = 0;
                                    vm.form.of.familiar.familiarObligations[2].obligationResidue = 0;
                                    vm.form.of.familiar.familiarObligations[2].obligationPaymentValue = 0;
                                    vm.$store.dispatch('setBalance', vm.$data).then(()=>{
                                        vm.form.i.equipment.locked = false;
                                        resolve();
                                    });
                                }).then(function(resolve){
                                    if(!vm.fabActions.filter(element=> element.name == 'toI').length > 0) {
                                        vm.fabActions.push({
                                            name: 'toI',
                                            icon: 'I'
                                        })
                                    }
                                    vm.toI();
                                });
                            }
                        }
                        else if(vm.$store.state.isGuarantor) {
                            if (vm.$store.state.assesments[vm.$store.state.actualAssesment].guarantors[vm.$store.state.assesments[vm.$store.state.actualAssesment].actualGuarantors].studies.length - 1 == 0) {
                                let promise = new Promise(function(resolve, reject) {
                                    vm.$store.dispatch('setBalance', vm.$data).then(()=>{
                                        vm.form.of.familiar.locked = false;
                                        resolve();
                                    });
                                }).then(function(resolve){
                                    if(!vm.fabActions.filter(element=> element.name == 'toOFU').length > 0) {
                                        vm.fabActions.push({
                                            name: 'toOFU',
                                            icon: 'OFU'
                                        })
                                    }
                                    vm.toOFU();
                                });
                            }
                            else {
                                let promise = new Promise(function(resolve, reject) {
                                    vm.form.of.familiar.familiarObligations[0].obligationAmount = 0;
                                    vm.form.of.familiar.familiarObligations[0].obligationResidue = 0;
                                    vm.form.of.familiar.familiarObligations[0].obligationPaymentValue = 0;
                                    vm.form.of.familiar.familiarObligations[1].obligationAmount = 0;
                                    vm.form.of.familiar.familiarObligations[1].obligationResidue = 0;
                                    vm.form.of.familiar.familiarObligations[1].obligationPaymentValue = 0;
                                    vm.form.of.familiar.familiarObligations[2].obligationAmount = 0;
                                    vm.form.of.familiar.familiarObligations[2].obligationResidue = 0;
                                    vm.form.of.familiar.familiarObligations[2].obligationPaymentValue = 0;
                                    vm.$store.dispatch('setBalance', vm.$data).then(()=>{
                                        vm.form.i.equipment.locked = false;
                                        resolve();
                                    });
                                }).then(function(resolve){
                                    if(!vm.fabActions.filter(element=> element.name == 'toI').length > 0) {
                                        vm.fabActions.push({
                                            name: 'toI',
                                            icon: 'I'
                                        })
                                    }
                                    vm.toI();
                                });
                            }
                        }
                    }
                    else if (scope == 'formOFU') {
                        var vm = this;
                        let promise = new Promise(function(resolve, reject) {
                            vm.$store.dispatch('setBalance', vm.$data).then(()=>{
                                vm.form.i.equipment.locked = false;
                                resolve();
                            });
                        }).then(function(resolve){
                            if(!vm.fabActions.filter(element=> element.name == 'toI').length > 0) {
                                vm.fabActions.push({
                                    name: 'toI',
                                    icon: 'I'
                                })
                            }
                            vm.toI();
                        });
                    }
                    else if (scope == 'formI') {
                        var vm = this;
                        let promise = new Promise(function(resolve, reject) {
                            vm.$store.dispatch('setBalance', vm.$data).then(()=>{
                                vm.form.cp.locked = false;
                                resolve();
                            });
                        }).then(function(resolve){
                            if(!vm.fabActions.filter(element=> element.name == 'toCP').length > 0) {
                                vm.fabActions.push({
                                    name: 'toCP',
                                    icon: 'CP'
                                })
                            }
                            vm.toCP();
                        });
                    }
                    else if (scope == 'formCP') {
                        var vm = this;
                        let promise = new Promise(function(resolve, reject) {
                            vm.$store.dispatch('setBalance', vm.$data).then(()=>{
                                vm.form.i.locked = false;
                                resolve();
                            });
                        }).then(function(resolve){
                            if(!vm.fabActions.filter(element=> element.name == 'toIFI').length > 0) {
                                vm.fabActions.push({
                                    name: 'toIFI',
                                    icon: 'IFI'
                                })
                            }
                            vm.toIFI();
                        });
                    }
                    else if (scope == 'formIFI') {
                        if(this.$store.state.isCustomer) {
                            if (this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy == 0) {
                                if (this.form.er.locked || this.form.if.locked || this.form.b.locked || this.form.of.locked || this.form.of.familiar.locked || this.form.i.equipment.locked || this.form.cp.locked || this.form.i.locked) {
                                    this.showNotificationError('Todas las secciones no han sido desbloqueadas, revisa y continúa');
                                    return
                                }
                            }
                            else {
                                if (this.form.er.locked || this.form.b.locked || this.form.of.locked || this.form.i.equipment.locked || this.form.cp.locked || this.form.i.locked) {
                                    this.showNotificationError('Todas las secciones no han sido desbloqueadas, revisa y continúa');
                                    return
                                }
                            }
                        }
                        if(this.$store.state.isGuarantor) {
                            if (this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1 == 0) {
                                if (this.form.er.locked || this.form.if.locked || this.form.b.locked || this.form.of.locked || this.form.of.familiar.locked || this.form.i.equipment.locked || this.form.cp.locked || this.form.i.locked) {
                                    this.showNotificationError('Todas las secciones no han sido desbloqueadas, revisa y continúa');
                                    return
                                }
                            }
                            else {
                                if (this.form.er.locked || this.form.b.locked || this.form.of.locked || this.form.i.equipment.locked || this.form.cp.locked || this.form.i.locked) {
                                    this.showNotificationError('Todas las secciones no han sido desbloqueadas, revisa y continúa');
                                    return
                                }
                            }
                        }
                        if (!this.$store.state.syncReturn) {
                            var vm = this;
                            var sum = 0;
                            for (let i=0;i<vm.form.i.financialIndicators.length;i++) {
                                if (isNaN(vm.form.i.financialIndicators[i].value) || vm.form.i.financialIndicators[i].value == 'Infinity') {
                                    sum = sum + 1;
                                }
                            }
                            if (sum > 0) {
                                swal({
                                    title: '¿Está seguro?',
                                    text: 'Algunos indicadores necesitan atención, si continúas esos valores quedarán en 0',
                                    type: 'warning',
                                    showCancelButton: true,
                                    confirmButtonText: 'Si, continuar',
                                    cancelButtonText: 'No, cancelar',
                                    confirmButtonClass: 'btn btn-success btn-fill',
                                    cancelButtonClass: 'btn btn-danger btn-fill',
                                    buttonsStyling: false
                                }).then(() => {
                                    vm.modifiedFinancialIndicators = false;
                                    for (let i=0;i<vm.form.i.financialIndicators.length;i++) {
                                        if (isNaN(vm.form.i.financialIndicators[i].value) || vm.form.i.financialIndicators[i].value == 'Infinity') {
                                            var assign_var = 0;
                                            vm.form.i.financialIndicators[i].value = assign_var;
                                        }
                                    }
                                    vm.$store.dispatch('setBalance', vm.$data).then(()=>{
                                        var payload = {
                                            stage: 'Registro de balance',
                                            description: 'Se ingresan todos los datos del balance con alerta de atención de indicadores.',
                                            dateTime: moment().format()
                                        };
                                        vm.$store.dispatch('setChangeLog', payload).then(()=>{
                                            if (vm.$store.state.assesments[vm.$store.state.actualAssesment].customer.actualStudy == 0) {
                                                vm.$router.push('/asessments/new_asessment/customer/others/character_analysis');
                                            }
                                            else {
                                                vm.$router.push('/asessments/new_asessment/customer/others/financial_indicators_consumer');
                                            } 
                                        });
                                    });
                                    
                                }, function (dismiss) {
                                    // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
                                    swal({
                                        title: 'Cancelado',
                                        text: 'El analista no ha continuado',
                                        type: 'error',
                                        confirmButtonClass: 'btn btn-info btn-fill',
                                        buttonsStyling: false
                                    })
                                })
                            }
                            else {
                                vm.$store.dispatch('setBalance', vm.$data).then(()=>{
                                    var payload = {
                                        stage: 'Registro de balance',
                                        description: 'Se ingresan todos los datos del balance.',
                                        dateTime: moment().format()
                                    };
                                    vm.$store.dispatch('setChangeLog', payload).then(()=>{
                                        if (vm.$store.state.assesments[vm.$store.state.actualAssesment].customer.actualStudy == 0) {
                                            vm.$router.push('/asessments/new_asessment/customer/others/character_analysis');
                                        }
                                        else {
                                            vm.$router.push('/asessments/new_asessment/customer/others/financial_indicators_consumer');
                                        }
                                    });
                                });
                            }
                        }
                        else if (this.$store.state.syncReturn) {
                            var vm = this;
                            var sum = 0;
                            for (let i=0;i<vm.form.i.financialIndicators.length;i++) {
                                if (isNaN(vm.form.i.financialIndicators[i].value) || vm.form.i.financialIndicators[i].value == 'Infinity') {
                                    sum = sum + 1;
                                }
                            }
                            if (sum > 0) {
                                swal({
                                    title: '¿Está seguro?',
                                    text: 'Algunos indicadores necesitan atención, si continúas esos valores quedarán en 0',
                                    type: 'warning',
                                    showCancelButton: true,
                                    confirmButtonText: 'Si, continuar',
                                    cancelButtonText: 'No, cancelar',
                                    confirmButtonClass: 'btn btn-success btn-fill',
                                    cancelButtonClass: 'btn btn-danger btn-fill',
                                    buttonsStyling: false
                                }).then(() => {
                                    vm.modifiedFinancialIndicators = false;
                                    for (let i=0;i<vm.form.i.financialIndicators.length;i++) {
                                        if (isNaN(vm.form.i.financialIndicators[i].value) || vm.form.i.financialIndicators[i].value == 'Infinity') {
                                            var assign_var = 0;
                                            vm.form.i.financialIndicators[i].value = assign_var;
                                        }
                                    }
                                    vm.$store.dispatch('setBalance', vm.$data).then(()=>{
                                        var payload = {
                                            stage: 'Registro de balance',
                                            description: 'Se ingresan todos los datos del balance con alerta de atención de indicadores.',
                                            dateTime: moment().format()
                                        };
                                        vm.$store.dispatch('setChangeLog', payload).then(()=>{
                                            vm.$store.dispatch('finishEvaluation', 'customer').then(()=>{
                                                vm.$router.push('/asessments/new_asessment/customer/others/assesment_sync'); 
                                            });
                                        });
                                    });
                                    
                                }, function (dismiss) {
                                    // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
                                    swal({
                                        title: 'Cancelado',
                                        text: 'El analista no ha continuado',
                                        type: 'error',
                                        confirmButtonClass: 'btn btn-info btn-fill',
                                        buttonsStyling: false
                                    })
                                })
                            }
                            else {
                                vm.$store.dispatch('setBalance', vm.$data).then(()=>{
                                    var payload = {
                                        stage: 'Registro de balance',
                                        description: 'Se ingresan todos los datos del balance.',
                                        dateTime: moment().format()
                                    };
                                    vm.$store.dispatch('setChangeLog', payload).then(()=>{
                                        vm.$store.dispatch('finishEvaluation', 'customer').then(()=>{
                                            vm.$router.push('/asessments/new_asessment/customer/others/assesment_sync'); 
                                        });
                                    });
                                });
                            }
                        }
                    } 
                }
                else {
                    this.$el.querySelector('[data-vv-id="'+this.$validator.errors.items[0].scope+'.'+this.$validator.errors.items[0].field+'"]').focus();
                }
            });
        }
    },
    mounted () {
        if (this.$store.state.isCustomer) {
            var product = this.$store.getters.getProductTypes.find(product => product.id == this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].productType);
            this.productValidator(product);
            if (this.consumer) {
                if (this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].balance.length != 0) {
                    if (typeof this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].balance[0].if.otherIncomes !== 'undefined') {
                        this.$data.form = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].balance[0];
                    }
                    else {
                        this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].balance[0].if.otherIncomes = [];
                        this.$data.form = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].balance[0];
                    }
                    this.fabActions = this.fabActions2;
                }
                else {
                    if (this.form.cp.paymentCapacity.length == 0) {
                        for (let i=0; i<PaymentCapacity.length;i++) {
                            this.form.cp.paymentCapacity.push({
                                id: PaymentCapacity[i].id ,
                                name: PaymentCapacity[i].name ,
                                formula: PaymentCapacity[i].formula,
                                info: PaymentCapacity[i].info,
                                value: 0
                            })
                        }
                    }
                    if (this.form.i.financialIndicators.length == 0) {
                        for (let i=0; i<FinancialIndicators.length;i++) {
                            this.form.i.financialIndicators.push({
                                id: FinancialIndicators[i].id ,
                                name: FinancialIndicators[i].name ,
                                alert: FinancialIndicators[i].alert ,
                                unit: FinancialIndicators[i]. unit,
                                formula: FinancialIndicators[i].formula,
                                info: FinancialIndicators[i].info,
                                value: 0
                            })
                        }
                    }
                }
                this.form.b.assets.accounts_receivable = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].layoffs + this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].interestLayoffs + this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].extraPayment;
                this.form.if.incomes.titular_salary = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].netSalary;
                if (typeof this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse !== 'undefined' && !_.isEmpty(this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse) && this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies.length > 0) {
                    var product = this.$store.getters.getProductTypes.find(product => product.id == this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[0].productType);
                    if (product.name.toLowerCase() == 'consumo') {
                        this.form.if.incomes.spouse_salary = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[0].balance[0].if.incomes.total * 0.7;
                    }
                    else if (product.name.toLowerCase() == 'microcrédito' || product.name.toLowerCase() == 'microcredito') {
                        // this.form.if.incomes.spouse_salary = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[0].balance[0].er.net_profit * 0.7;
                        this.form.if.incomes.spouse_salary = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[0].balance[0].er.net_profit * 0.7;
                    }
                }
                else {
                    this.form.if.incomes.spouse_salary = 0;
                }
            }
            else {
                this.showNotificationError('Esta sección no está permitida');
            }
        }
        else if(this.$store.state.isSpouse) {
            var product = this.$store.getters.getProductTypes.find(product => product.id == this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].productType);
            this.productValidator(product);
            if (this.consumer) {
                if (this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].balance.length != 0) {
                    if (typeof this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].balance[0].if.otherIncomes !== 'undefined') {
                        this.$data.form = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].balance[0];
                    }
                    else {
                        this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].balance[0].if.otherIncomes = [];
                        this.$data.form = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].balance[0];
                    }
                    this.fabActions = this.fabActions2;
                }
                else {
                    if (this.form.cp.paymentCapacity.length == 0) {
                        for (let i=0; i<PaymentCapacity.length;i++) {
                            this.form.cp.paymentCapacity.push({
                                id: PaymentCapacity[i].id ,
                                name: PaymentCapacity[i].name ,
                                formula: PaymentCapacity[i].formula,
                                info: PaymentCapacity[i].info,
                                value: 0
                            })
                        }
                    }
                    if (this.form.i.financialIndicators.length == 0) {
                        for (let i=0; i<FinancialIndicators.length;i++) {
                            this.form.i.financialIndicators.push({
                                id: FinancialIndicators[i].id ,
                                name: FinancialIndicators[i].name ,
                                alert: FinancialIndicators[i].alert ,
                                unit: FinancialIndicators[i]. unit,
                                formula: FinancialIndicators[i].formula,
                                info: FinancialIndicators[i].info,
                                value: 0
                            })
                        }
                    }
                }
                this.form.b.assets.accounts_receivable = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].layoffs + this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].interestLayoffs + this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].extraPayment;
                this.form.if.incomes.titular_salary = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].netSalary;
            }
            else {
                this.showNotificationError('Esta sección no está permitida');
            }
        }
        if (this.$store.state.isGuarantor) {
            var product = this.$store.getters.getProductTypes.find(product => product.id == this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].productType);
            this.productValidator(product);
            if (this.consumer) {
                if (this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].balance.length != 0) {
                    if (typeof this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].balance[0].if.otherIncomes !== 'undefined') {
                        this.$data.form = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].balance[0];
                    }
                    else {
                        this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].balance[0].if.otherIncomes = [];
                        this.$data.form = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].balance[0];
                    }
                    this.fabActions = this.fabActions2;
                }
                else {
                    if (this.form.cp.paymentCapacity.length == 0) {
                        for (let i=0; i<PaymentCapacity.length;i++) {
                            this.form.cp.paymentCapacity.push({
                                id: PaymentCapacity[i].id ,
                                name: PaymentCapacity[i].name ,
                                formula: PaymentCapacity[i].formula,
                                info: PaymentCapacity[i].info,
                                value: 0
                            })
                        }
                    }
                    if (this.form.i.financialIndicators.length == 0) {
                        for (let i=0; i<FinancialIndicators.length;i++) {
                            this.form.i.financialIndicators.push({
                                id: FinancialIndicators[i].id ,
                                name: FinancialIndicators[i].name ,
                                alert: FinancialIndicators[i].alert ,
                                unit: FinancialIndicators[i]. unit,
                                formula: FinancialIndicators[i].formula,
                                info: FinancialIndicators[i].info,
                                value: 0
                            })
                        }
                    }
                }
                this.form.b.assets.accounts_receivable = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].layoffs + this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].interestLayoffs + this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].extraPayment;
                this.form.if.incomes.titular_salary = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].netSalary;
            }
            else {
                this.showNotificationError('Esta sección no está permitida');
            }
        }
    }
}
</script>
<style>
.fab-main .material-icons{
    color: black !important;
    background-color: #F09500 !important;
}
.fab-list li .material-icons{
    color: black !important;
    font-family: "Helvetica Neue" !important;
    font-size: 12px !important;
}
.center-title {
        margin-top: 0;
        margin-bottom: 0;
    }
.orange {
    color: #F09500;
}
.white {
    color: white;
}
</style>